// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      // Header translations (existing)
      signIn: "Sign In / Register",
      dashboard: "Dashboard",
      bookings: "My Bookings",
      settings: "Profile Settings",
      logout: "Sign Out",
      allRightsReserved: "All rights reserved",
      backToTop: "Back to top",
      
      // Home page translations (new)
      // Hero Section
      heroLabel1: "Desert Escapes · Oman",
      heroHeadline1_1: "Journey Into",
      heroHeadline1_2: "The Golden",
      heroHeadline1_3: "Sands of Oman",
      heroSub1: "Endless dunes, star-lit camps and ancient Bedouin trails await in the Wahiba Desert.",
      heroCta1: "Explore Desert Tours",
      
      heroLabel2: "Heritage & Culture · Muscat",
      heroHeadline2_1: "Discover the",
      heroHeadline2_2: "Soul of",
      heroHeadline2_3: "Muscat",
      heroSub2: "Grand mosques, royal fortresses and the scent of frankincense guide your journey.",
      heroCta2: "Explore Muscat",
      
      heroLabel3: "Coastal Luxury · Musandam",
      heroHeadline3_1: "Sail the",
      heroHeadline3_2: "Fjords of",
      heroHeadline3_3: "Musandam",
      heroSub3: "Crystal fjords, traditional dhows and pristine reefs where the sea meets the sky.",
      heroCta3: "Explore Cruises",
      
      contactUs: "Contact Us",
      
      // Search Bar
      travelDates: "Travel Dates",
      destination: "Destination",
      tripType: "Trip Type",
      destinationPlaceholder: "Muscat, Salalah, Dubai…",
      allTypes: "All Types",
      desertSafari: "Desert Safari",
      culturalTour: "Cultural Tour",
      coastalSea: "Coastal & Sea",
      mountainTrek: "Mountain Trek",
      
      // Stats
      destinationsCovered: "Destinations Covered",
      travellersServed: "Travellers Served",
      visaApprovalRate: "Visa Approval Rate",
      yearsOfExpertise: "Years of Expertise",
      
      // Destinations
      exploreTheWorld: "Explore the World",
      premiumDestinations: "Premium Destinations",
      handpickedEscapes: "Handpicked escapes across Oman, the Gulf and beyond",
      viewAll: "View all",
      featured: "Featured",
      popular: "Popular",
      
      // Featured Trips
      curatedJourneys: "Curated Journeys",
      featuredTrips: "Featured Trips",
      expertlyCrafted: "Expertly crafted itineraries for every type of explorer",
      
      // Trip details
      from: "From",
      bookNow: "Book Now",
      topRated: "Top Rated",
      bestSeller: "Best Seller",
      editorsPick: "Editor's Pick",
      luxury: "Luxury",
      
      // How It Works
      simpleProcess: "Simple Process",
      howItWorks: "How It Works",
      step1Title: "Search Your Visa or Trip",
      step1Text: "Enter your destination, nationality and travel dates to find matching options.",
      step2Title: "Choose a Package",
      step2Text: "Select the visa type or tour package that fits your schedule and budget.",
      step3Title: "Submit Documents",
      step3Text: "Upload documents securely through our guided online portal in minutes.",
      step4Title: "Travel with Confidence",
      step4Text: "Receive your visa or itinerary confirmation and set off worry-free.",
      
      // Why Choose Us
      ourStrengths: "Our Strengths",
      whyChooseUs: "Why Choose Us",
      trustText: "Trusted by thousands of Omani travellers since 2014",
      expertGuidesTitle: "Expert Local Guides",
      expertGuidesText: "Our Omani-born specialists bring authentic cultural depth to every experience.",
      endToEndTitle: "End-to-End Planning",
      endToEndText: "Visa, flights, hotels, transfers and tours — all handled under one roof.",
      guaranteedApprovalsTitle: "Guaranteed Approvals",
      guaranteedApprovalsText: "98% visa approval record backed by 10+ years of embassy relationships.",
      support247Title: "24/7 Travel Support",
      support247Text: "Round-the-clock assistance before, during and after your journey.",
      
      // Visa Pricing
      transparentPricing: "Transparent Pricing",
      visaPackages: "Visa Packages",
      visaSubtitle: "Flexible options designed for every type of traveller from Oman",
      mostPopular: "Most Popular",
      singleEntry: "Single Entry",
      multipleEntry: "Multiple Entry",
      serviceType: "Service Type",
      processingTime: "Processing Time",
      useValidity: "Use Validity",
      stayValidity: "Stay Validity",
      applyNow: "Apply Now",
      
      // Testimonials
      socialProof: "Social Proof",
      whatClientsSay: "What Our Clients Say",
      
      // Special Offers
      limitedTime: "Limited Time",
      seasonalSpecialOffers: "Seasonal Special Offers",
      specialOffersSub: "Plan ahead and enjoy significant savings with early booking",
      
      // Common
      properties: "properties",
      reviews: "reviews",
      days: "Days",
      hours: "hours",

      home: "Home",
visas: "Visas",
schengen: "Schengen",
tours: "Tours",
promotions: "Promotions",
flights: "Flights",
carRental: "Car rental",
information: "Information",
visaApplication: "Visa application",
trackApplication: "Track application",
visaShengen: "Visa Schengen",
dummyTicket: "Dummy ticket",
insurance: "Insurance",

contact: "Contact",
contactTitle: "We'd love to hear from you",
contactSubtitle: "Reach out via any channel below — our team responds fast.",
whatsapp: "WhatsApp",
whatsappDesc: "Fastest response",
startChat: "Start Chat Now",
callUs: "Call Us",
available247: "Available 24/7",
emailUs: "Email Us",
emailResponse: "We reply within 2 hours",
location: "Location",
viewOnMap: "View on Map",
whatsapp247: "WhatsApp 24/7",
sendMessage: "Send Us a Message",
teamResponse: "Our team replies within 2 hours",
fullName: "Full Name",
fullNamePlaceholder: "John Doe",
emailAddress: "Email Address",
phoneNumber: "Phone Number",
phonePlaceholder: "+971 50 000 0000",
subject: "Subject",
subjectPlaceholder: "How can we help?",
yourMessage: "Your Message",
messagePlaceholder: "Tell us about your trip, questions or requests...",
sendMessageBtn: "Send Message",
faqTitle: "Frequently Asked Questions",


// FAQ Questions & Answers
faqQ1: "What do I need to hire a car?",
faqA1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.",

faqQ2: "How old do I have to be to rent a car?",
faqA2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.",

faqQ3: "Can I book a hire car for someone else?",
faqA3: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.",

faqQ4: "How do I find the cheapest car hire deal?",
faqA4: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.",

faqQ5: "What should I look for when I'm choosing a car?",
faqA5: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.",

// Help Block
helpTitle1: "Booking your activity",
helpText1: "Lorem ipsum is placeholder text commonly used in site.",
helpTitle2: "Payment & receipts",
helpText2: "Lorem ipsum is placeholder text commonly used in site.",
helpTitle3: "Booking changes & refunds",
helpText3: "Lorem ipsum is placeholder text commonly used in site.",
helpTitle4: "Promo codes & credits",
helpText4: "Lorem ipsum is placeholder text commonly used in site.",
helpTitle5: "On the participation day",
helpText5: "Lorem ipsum is placeholder text commonly used in site.",
helpTitle6: "Value Packs",
helpText6: "Lorem ipsum is placeholder text commonly used in site.",

silverJarzTravel: "Silver Jarz Travel & Tourism",
heroTitle1: "Your journey,",
heroTitle2: "perfectly planned.",
heroDescription: "With years of expertise across the GCC and Arab world, we make travel seamless — from visas to holiday packages and everything in between.",

// About Page - About Us
aboutUs: "About Us",
aboutHeadline1: "We put your comfort",
aboutHeadline2: "above everything else.",
aboutText1: "At <strong style='color: var(--teal); font-weight: 600;'>Silver Jarz Travel & Tourism</strong>, your comfort comes first. With years of expertise in the travel and tourism industry, we provide integrated solutions including visas, flight tickets, insurance, and tailor-made holiday packages.",
aboutText2: "Whether you're planning a business trip or a family getaway, our team is dedicated to delivering seamless, memorable travel experiences across the GCC and the broader Arab world.",
badgeYears: "12+",
badgeText: "Years of excellence\nin travel & tourism",
flightTickets: "Flight Tickets",
holidayPackages: "Holiday Packages",

// About Page - Mission & Vision
ourPurpose: "Our Purpose",
purposeHeadline1: "Driven by mission,",
purposeHeadline2: "guided by vision.",
ourMission: "Our Mission",
missionTitle: "Quality services at competitive prices",
missionText: "To deliver high-quality travel services at competitive prices with full commitment to transparency and speed — ensuring every client receives exactly what they need, when they need it.",
ourVision: "Our Vision",
visionTitle: "The #1 choice across the GCC & Arab world",
visionText: "To become the number one choice for clients across the GCC and the Arab world for all travel and tourism services — through innovation, trust, and unmatched client care.",

// About Page - Values
ourValues: "Our Values",
valuesHeadline1: "The principles that",
valuesHeadline2: "guide everything we do.",
valueTitle1: "Integrity & Transparency",
valueDesc1: "We operate with full honesty in every interaction, so you always know exactly what you're getting.",
valueTitle2: "Fast & Reliable Service",
valueDesc2: "Speed matters when you're planning a trip. We deliver quick, dependable solutions every time.",
valueTitle3: "24/7 Customer Support",
valueDesc3: "Our dedicated team is always available, no matter your time zone or travel destination.",
valueTitle4: "Innovative Tailored Solutions",
valueDesc4: "Every traveler is unique. We craft personalized packages that fit your needs perfectly.",

// About Page - Why Us
whyUs: "Why Us",
whyHeadline1: "Why travelers choose",
whyHeadline2: "Silver Jarz",

// About Page - Testimonials
testimonials: "Testimonials",
testimonialsHeadline1: "Overheard from our",
testimonialsHeadline2: "happy travelers",

// Add to en.translation object:

backToHome: "Back to Home",
legalNotice: "Legal Notice",
termsTitle: "Terms & Conditions",
termsSubtitle: "Last updated: January 2026",
introduction: "Introduction",
general: "General",
termsIntro1: "These terms and conditions govern your use of the silverjarz.com website. By accessing and using the website, the user agrees to comply with the terms and conditions set forth in this legal notice.",
termsIntro2: "The following terms apply to these terms and conditions, privacy policy, disclaimer notice, and all agreements: The words \"Customer,\" \"You,\" and \"Your\" refer to you, the person logging into this website and agreeing to the company's terms and conditions. The terms \"Company,\" \"We,\" \"Us,\" and \"Our\" refer to our company. The terms \"Party,\" \"Parties,\" and \"We\" refer to both the Customer and ourselves.",
termsIntro3: "All terms refer to the offer, acceptance, and consideration of payment necessary to undertake the process of providing assistance to the Customer in the most appropriate manner for the express purpose of meeting the Customer's needs regarding the provision of the Company's stated services, in accordance with and subject to the applicable law of the OMAN.",
changesToTerms: "Changes to Terms",
updated: "Updated",
changesText1: "silverjarz.com reserves the right to change, modify, add, or delete parts of these terms and conditions in whole or in part from time to time. Changes to these terms and conditions become effective immediately upon posting on this website.",
changesText2: "The user should periodically review these terms and conditions on the website to check for any changes or updates. Continued use of this website after changes or updates are posted constitutes notice of the user's agreement to be bound by and comply with these terms and conditions, including such changes or updates.",
important: "⚠️ Important:",
changesText3: "Using the services of this website without reading the terms and conditions is considered negligence on the part of the user, and any inconvenience arising later is the user's responsibility.",
processingTimes: "Processing Times",
timing: "Timing",
expressProcessing: "Express Visa Processing",
expressText: "The fast visa processing time mentioned anywhere on the website is 24 working hours.",
expressRefund: "If your express visa is not approved within 24 working hours, the additional fee charged for the express option will be refunded.",
standardProcessing: "Standard Processing",
standardText: "The approval time mentioned anywhere on the website is the standard time from the Immigration Department. In rare cases, obtaining approval may take longer.",
timezoneInfo: "The timeframe mentioned on the website is according to Gulf Standard Time (GST), and working hours begin at 8:00 AM GST.",
holidayInfo: "Saturday and Sunday are holidays for the Immigration Department. Even if the customer applies for an express visa on Friday, the Immigration Department will not begin processing until Monday at 8:00 AM GST.",
documentsInfo: "Travel documents are not accepted for OMAN visa applications. Only ordinary passports are permitted.",
liability: "Liability",
disclaimer: "Disclaimer",
liabilityText: "silverjarz.com shall not be held liable for any disruption to your travel caused by any type of hotel booking cancellation or flight cancellation.",
privacyPolicy: "Privacy Policy",
dataProtection: "Data Protection",
privacyText1: "silverjarz.com sells OMAN visas online. The private information required to process orders submitted through the e-commerce service, including user personal information, credit card details, and phone numbers, is kept in strict confidence and will not be sold or disclosed to third parties.",
creditCard: "🔒 Credit Card Information:",
creditCardText: "silverjarz.com does not retain credit card details under any circumstances.",
privacyText2: "Your access to and use of our website is also subject to your acceptance of and compliance with the company's Privacy Policy. By agreeing to the terms and conditions, you are required to disclose the following information to us. We collect name, email address, mobile number, passport details, photograph, and country of residence/nationality.",
privacyText3: "The information collected may be used to customize our products and services, promotions, advertising, and/or to communicate with you.",
pricingPolicy: "Pricing Policy",
pricing: "Pricing",
pricingText1: "The company reserves the right to amend its prices at any time before accepting an order.",
pricingText2: "The company may revise quoted prices after receiving an order in the event of any circumstance affecting delivery due to government action, foreign exchange cost increases, or any other matter beyond the company's control.",
paymentPolicy: "Payment Policy",
payment: "Payment",
paymentText1: "Payment can be made through various available payment methods, such as Visa or MasterCard.",
paymentText2: "Payment cards (credit or debit) are subject to validation and authorization checks by your card issuer. If we do not receive the required authorization, we will not be liable for any delay or non-delivery of your order.",
refundPolicy: "Refund Policy",
refunds: "Refunds",
refundText1: "Visa approval is subject entirely to the discretion of immigration officials.",
refundText2: "silverjarz.com assumes no liability for the rejection of any visa applications.",
refundText3: "Once a visa application is submitted, it will be processed immediately.",
refundText4: "Visa application fees are non-refundable in the event of rejection by the Immigration Department.",
refundText5: "For cancellation or refund requests, please note that such requests are only accepted if submitted within 3 hours of payment and before the application processing begins. A non-refundable service fee of 6.7% of the total amount will be deducted. The remaining balance will be handled according to the cancellation terms specified by the service providers.",
expressRefundPolicy: "Express Visa Refund Policy",
express: "Express",
expressRefundTitle: "📋 Express Processing Refund:",
expressRefundText1: "If you have applied for a OMAN express visa and your application has not been processed within 36 hours, you will be eligible for a refund of the express processing fee (USD 50).",
expressRefundText2: "Please note that this refund applies only to the express processing fee and does not include the standard visa application fee.",
expressRefundContact: "For refund requests, please contact our support team with your order number.",
termsFooter: "© 2026 silverjarz.com - All rights reserved. These terms and conditions are governed by the laws of the OMAN.",

company: "Company",
support: "Support",
otherServices: "Other Services",
blog: "Blog",
faq: "FAQ",
termsAndConditions: "Terms and Conditions",
carHire: "Car Hire",
activityFinder: "Activity Finder",
tourList: "Tour List",
flightFinder: "Flight Finder",
cruiseTicket: "Cruise Ticket",
holidayRental: "Holiday Rental",
travelAgents: "Travel Agents",

// Payment Guidelines - English
paymentGuidelines: "Payment Guidelines",
paymentTitle: "Payment Guidelines – OMAN e-Visa",
paymentSubtitle: "Welcome to silverjarz.com, your trusted partner for OMAN e-visa services. Please read the following information carefully before proceeding with payment.",
whatsIncluded: "What's Included in the Payment",
coverage: "Coverage",
whatsIncludedIntro: "When applying for a OMAN e-visa through our system, the total cost covers:",
included1: "Processing & Support Fees – To process your application and provide guidance.",
included2: "OMAN Government & Administrative Fees – Official fees for pre-approval of the visa.",
transparent: "✅ Transparent Pricing:",
transparentText: "Our transparent pricing ensures you understand exactly what your payment covers.",
paymentOptions: "Accepted Payment Options",
secure: "Secure",
paymentOptionsIntro: "We offer fast, secure online payment processing using major credit and debit cards:",
visaCard: "Credit/Debit",
mastercard: "Credit/Debit",
amex: "Credit Card",
applePay: "Mobile Payment",
googlePay: "Mobile Payment",
importantNotes: "Important Notes:",
paymentNote1: "All payments are processed in US Dollars (USD)",
paymentNote2: "Transactions will appear on your statement as: Silverjarz trading contracting",
paymentNote3: "You will be required to enter Cardholder Name, Billing Address, Card Number, Expiry Date, and CVV Code",
paymentNote4: "3D Secure authentication (OTP from your bank) may be required",
security: "🔒 Security:",
securityText: "We protect your data using TLS encryption and follow PCI DSS standards to ensure transaction security.",
paymentResults: "Payment Results",
outcome: "Outcome",
successTitle: "✅ Payment Successful:",
successText: "A confirmation message will appear on screen. An email confirmation will be sent to you shortly after.",
failTitle: "❌ Payment Failed:",
failText: "An error message will be displayed explaining the reason for failure.",
importantNote: "⚠️ Important Note:",
importantNoteText: "All fees are in US Dollars (USD).",
needHelp: "Need Help?",

needHelpText: "Our customer service team is available 24/7 to assist you with payment-related matters or any questions about your visa application.",
contactSupport: "Contact Support",
contactSupportText: "Reach out via WhatsApp, phone, or email for immediate assistance.",
provideOrder: "Provide Order Details",
provideOrderText: "Have your order number and payment reference ready for faster service.",
resolveIssue: "Resolve Issues",
resolveIssueText: "Our team will work with you to resolve any payment or application issues.",
confirmation: "Confirmation",
confirmationText: "You'll receive confirmation once your issue has been resolved.",
readyToApply: "Ready to Apply?",
readyToApplyText: "Start your OMAN e-visa application process today.",
applyNowBtn: "Apply Now",
paymentInstructions:"Payment Instructions",

// Privacy Policy - English
privacyPolicyLabel: "Privacy Policy",
privacyTitle: "Privacy Policy",
privacySubtitle: "Last updated: January 2026",
companyInfo: "Company Information",
companyInfoText: "This privacy policy describes how SilverJarz trading contracting (\"We\", \"Us\", \"Our\") collects, uses, and protects your personal information when you use the services provided at https://silverjaz.com",
companyInfoText2: "silverjarz.com is a service platform owned and managed by SilverJarz trading contracting, a licensed tourism company based in khasab musandam, OMAN (License No. 2644940.01). This website operates as an official part of our services, focusing on assisting individuals with OMAN visit visa applications and related tourism services.",
consentText: "By using this website and our services, you agree to the collection and use of your personal information in accordance with this Privacy Policy.",
purposeTitle: "Purpose of Data Collection",
dataCollection: "Data Collection",
purposeText: "The primary purpose of collecting your personal data is to provide you with our services related to:",
purpose1: "OMAN visit visa application assistance",
purpose2: "Tourism packages and holiday bookings",
purpose3: "Customer support and follow-up",
purposeHighlight: "We only collect data that is necessary to effectively provide these services and comply with legal requirements.",
infoTypesTitle: "Type of Information Collected",
infoTypesText: "To provide you with personalized and efficient services, we collect the necessary personal and technical data to process visa applications, improve services, and comply with legal requirements.",
personalInfo: "Personal Information",
personalInfoText: "Includes your name, email address, phone number, and other essential information important for processing visa applications and related government transactions.",
technicalData: "Technical Data",
technicalDataText: "Includes information such as your IP address, browser type, operating system, and access logs, which help us understand user behavior and improve website performance.",
cookiesText: "We use cookies and similar tracking technologies to personalize your experience and analyze website traffic. Cookies are small files stored on your device that help recognize returning visitors or remember preferences.",
howWeUseTitle: "How We Use Your Information",
usage: "Usage",
use1: "Your personal information is essential for facilitating visa applications or other government services.",
use2: "We use your information to respond to inquiries, provide assistance, and improve our support services.",
use3: "We analyze technical data to enhance website functionality and ensure a consistent user experience.",
use4: "We may process your data to comply with legal and regulatory obligations.",
storageTitle: "Data Storage and Retention",
retention: "Retention",
storageText: "Your data is securely stored on protected servers and access is limited to authorized personnel only. We retain your personal data for as long as necessary to:",
storage1: "Fulfill the services you have requested",
storage2: "Meet legal or compliance obligations",
storageHighlight: "We retain personal data until we no longer need it, as required by OMAN law, after which it is securely deleted or anonymized.",
sharingTitle: "Data Sharing and Disclosure",
disclosure: "Disclosure",
noSell: "🚫 We do NOT sell or rent your personal information to any third party.",
sharingText: "Your data may be shared with:",
share1: "OMAN government departments involved in visa processing",
share2: "Payment processing partners (e.g., Stripe)",
share3: "Trusted tour and service partners under confidentiality agreements",
share4: "Legal authorities when required by OMAN law",
cookiesTitle: "Cookies and Tracking Technologies",
tracking: "Tracking",
cookiesText2: "Our website uses cookies to enhance your browsing experience and analyze usage. Cookies help us:",
cookie1: "Remember your preferences",
cookie2: "Improve performance and user experience",
cookie3: "Collect anonymous visitor statistics (e.g., via Google Analytics)",
cookieOptOut: "You can choose to disable cookies in your browser settings, but this may affect some website features.",
clarityTitle: "Microsoft Clarity",
analytics: "Analytics",
clarityText: "We use Microsoft Clarity to better understand how users interact with our website and to improve their overall experience. Clarity captures user behavior such as clicks, scrolls, and mouse movements through anonymized session recordings and heatmaps.",
clarityText2: "Clarity may use cookies and other tracking technologies for this purpose. All data collected is anonymized and does not include personal information.",
clarityConsent: "By using our website, you consent to the processing of your data by Microsoft Clarity in accordance with Microsoft's Privacy Statement.",
rightsTitle: "Your Rights and Choices",
yourRights: "Your Rights",
rightsText: "You have specific rights regarding your personal data. You can request access to, update, and correct your personal information as appropriate.",
right1: "Request deletion of your personal information subject to legal and contractual obligations",
right2: "Unsubscribe from receiving our marketing communications at any time",
rightsContact: "To exercise any of these rights, please contact our support team.",
securityTitle: "Data Security",
security2: "Security",

externalLinksTitle: "External Links",
links: "Links",
externalLinksText: "Our website may contain links to third-party websites. This Privacy Policy does not apply to those websites, and we are not responsible for their content or data handling practices.",
updatesTitle: "Policy Updates",
updates: "Updates",
updatesText: "We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date. Please review this page regularly to stay informed.",
disclaimerTitle: "Disclaimer",
disclaimer2: "Disclaimer",
disclaimerText: "We are a private sector advisory and facilitation service provider, operated by SilverJarz trading contracting, a licensed tourism company based in khasab musandam, OMAN (License No. 2644940.01) for visa applications. We are not affiliated with any government entity and do not have the authority to approve or deny visa applications.",
disclaimerText2: "By using our website and services, you acknowledge and agree to the terms outlined in this Privacy Policy. Your trust is very important to us, and we are committed to protecting your personal information with the utmost care. We strive to make the visa application process smooth and secure.",
commitment: "Our Commitment:",
commitmentText: "Our commitment to privacy ensures your personal information is handled according to the highest standards of security and confidentiality. Trust us to be a reliable partner in navigating the complexities of visa applications, providing you with expert guidance and support every step of the way.",
// Legal Disclaimer - English
legalDisclaimerLabel: "Legal Disclaimer",
legalDisclaimerTitle: "Legal Disclaimer",
legalDisclaimerSubtitle: "Last updated: January 2026",
disclaimerCompanyInfo: "Company Information",
disclaimerCompanyText: "This website, silverjarz.com, is owned and operated by SilverJarz trading contracting (License No. 2404940.01). We are a private, independent agency specializing in travel consultancy and OMAN visa documentation support.",
disclaimerImportant: "⚠️ Important Notice:",
disclaimerMain: "Please be aware that silverjarz.com is a non-governmental entity and is not affiliated with, endorsed by, or connected to the OMAN government or any official immigration authority. Our professional services incur a service fee separate from mandatory government fees.",
keyPointsTitle: "Key Points to Understand",
privateAgency: "Private Agency",
privateAgencyText: "We are a private sector advisory and facilitation service provider, not a government entity.",
serviceFees: "Service Fees",
serviceFeesText: "Our professional services incur a service fee separate from mandatory government visa fees.",
governmentOption: "Government Option",
governmentOptionText: "Individuals who wish to apply for a visa independently can do so through official government portals at a reduced cost.",
facilitationOnly: "Facilitation Only",
facilitationOnlyText: "We assist in facilitating administrative procedures for travel documentation but do not make approval decisions.",
detailedInfo: "Detailed Information",
details: "Details",
entityType: "Entity Type:",
entityTypeText: "Private limited company registered in khasab musandam, OMAN",
license: "License:",
licenseText: "SilverJarz trading contracting - License No. 2404940.01",
affiliation: "Affiliation:",
affiliationText: "Independent - Not affiliated with any government entity",
services: "Services:",
servicesText: "Travel consultancy and OMAN visa documentation support",
summaryTitle: "Summary",
recap: "Recap",
summaryText: "By using this website, you acknowledge that we are a private service provider that assists in facilitating administrative procedures for travel documentation. We do not have the authority to approve or deny visa applications, and our services are separate from government processes.",
disclaimerFooter: "© 2026 silverjarz.com - All rights reserved. SilverJarz trading contracting",

// ── VISA TRANSLATIONS (EN) ──
visaValidationAlert: "Please select destination and nationality country.",
visaEyebrow: "Visa Services Worldwide",
visaHeroTitle1: "Your journey starts with",
visaHeroTitle2: "the right",
visaHeroTitleWord: "visa",
visaHeroSubtitle: "Expert guidance and seamless processing for over 190 destinations.",
visaTrustBadge: "Trusted by 50,000+ travelers",
visaDestinationLabel: "Destination",
visaDestinationPlaceholder: "Where are you going?",
visaNationalityLabel: "Nationality",
visaNationalityPlaceholder: "Your passport country",
visaLivingInLabel: "Living In",
visaLivingInPlaceholder: "Current residence",
visaFindBtn: "Find Visa",
visaLoading: "Loading...",
visaStepsEyebrow: "SIMPLE PROCESS",
visaStepsTitle: "How It Works",
visaStepsSubtitle: "Get your visa in 4 simple steps without the hassle of paperwork.",
visaStep1Title: "Select Destination",
visaStep1Desc: "Choose your destination country and nationality to see available visa options.",
visaStep2Title: "Upload Documents",
visaStep2Desc: "Fill out the online application and upload required documents securely.",
visaStep3Title: "Pay Online",
visaStep3Desc: "Complete your payment using our secure and encrypted payment gateways.",
visaStep4Title: "Get Your Visa",
visaStep4Desc: "Receive your official approved visa directly in your email inbox.",

bestPriceGuarantee: "Best Price Guarantee",
bestPriceGuaranteeText: "Transparent pricing on every visa, flight and rental — no hidden fees, ever.",
easyQuickBooking: "Easy & Quick Booking",
easyQuickBookingText: "Book visas, flights and tours in minutes, from any device, with instant confirmation.",
customerCare247: "Customer Care 24/7",
customerCare247Text: "Real people, day or night — our Muscat-based team is always one call away.",
handpickedDestinations: "Handpicked Destinations",
handpickedDestinationsText: "Curated hotels, drivers and experiences across Oman's most sought-after locations.",

trackEyebrow: "Live Portal Access",
      trackHeroTitle1: "Track Your Visa",
      trackHeroTitleWord: "Application",
      trackHeroSubtitle: "Enter your application reference code below for real-time embassy updates, status verification, and processing estimates.",
      trackInputPlaceholder: "e.g. VSA-8921-2026 or Passport Number",
      trackSubmitBtn: "Track Status",
      trackSearchingBtn: "Searching...",
      trackBadgeEncrypted: "256-Bit Encrypted",
      trackBadgeEmbassySync: "Direct Embassy Sync",
      trackBadgeSupport: "24/7 Priority Support",

      // Result Section
      trackRefCodeLabel: "Reference Code",
      trackDestinationLabel: "Destination",
      trackStatusPill: "Processing at Embassy",
      trackStep1Title: "Submitted",
      trackStep2Title: "Document Review",
      trackStep3Title: "Embassy Review",
      trackStep3Date: "In Progress",
      trackStep4Title: "Passport Ready",
      trackStep4Date: "Pending",
      trackEstCompletion: "Estimated Completion:",
      trackDownloadBtn: "Download Receipt",
      trackAlertDownload: "Downloading receipt...",

      trackFaqMainTitle: "Need Help Finding Your Application?",
      trackFaqMainSubtitle: "Common questions regarding tracking and reference numbers",
      trackFaqQ1Title: "Where do I find my reference number?",
      trackFaqQ1Desc: "Your unique tracking code was sent to your registered email address and SMS receipt right after payment completion.",
      trackFaqQ2Title: "How often is status updated?",
      trackFaqQ2Desc: "Status changes update automatically whenever our verification team or the destination embassy logs a file milestone.",
      trackFaqQ3Title: "Having trouble searching?",
      trackFaqQ3Desc: "Make sure your reference code is typed without extra spaces, or log into your client dashboard to view active applications.",

      scBadge: "Premier Schengen Visa Experts in Oman",
      scHeroTitle1: "Seamless Visa Solutions to",
      scHeroTitleWord: "Europe",
      scHeroSubtitle: "Experience stress-free travel preparation. We provide end-to-end guidance, guaranteed appointment scheduling, and meticulous application filing with a 94%+ approval rate.",
      scBookBtn: "Book Free Assessment",
      scOurProcessBtn: "Our Process",
      scTypesEyebrow: "Tailored Options",
      scTypesTitle: "Select Your Visa Type",
      scMostPopular: "Most Popular",
      scApplyUnderCat: "Apply Under This Category",

      scDestEyebrow: "Destinations",
      scDestTitle: "Explore 27 European Nations",

      scStepsEyebrow: "How It Works",
      scStepsTitle: "Four Steps to Your Visa",

      scDocsEyebrow: "Checklist",
      scDocsTitle: "Required Documents",

      scFaqEyebrow: "Got Questions?",
      scFaqTitle: "Frequently Asked Questions",

      scCtaEyebrow: "Get Started Today",
      scCtaTitle: "Ready to Plan Your Journey?",
      scCtaSubtitle: "Fill out the form to schedule a dedicated consultation with our Schengen visa specialists in Muscat.",
      scCtaLocation: "Muscat, Sultanate of Oman",
      scFormTitle: "Request Free Assessment",
      scFormName: "Your Full Name",
      scFormEmail: "Email Address",
      scFormPhone: "Phone / WhatsApp",
      scFormSelectDest: "Select Target Destination",
      scFormSubmitBtn: "Submit Request",

      // Types Data
      scType1Title: "Tourist / Short-Stay",
      scType1Code: "Type C Visa",
      scType1Duration: "Up to 90 Days",
      scType1F1: "Tourism & Vacation",
      scType1F2: "Family & Friend Visits",
      scType1F3: "Short Conferences",
      scType1F4: "Cultural Events",

      scType2Title: "Multiple Entry",
      scType2Code: "Long-Term Multi-Entry",
      scType2Duration: "1 to 5 Years Validity",
      scType2F1: "Frequent Business Travel",
      scType2F2: "Repeat Schengen Visitors",
      scType2F3: "Flexible European Access",
      scType2F4: "Priority Consultation",

      scType3Title: "Transit Visa",
      scType3Code: "Type A / B Visa",
      scType3Duration: "Short Stopover",
      scType3F1: "Airport Transit",
      scType3F2: "En-route Connecting Flights",
      scType3F3: "Short Layover Access",
      scType3F4: "Immediate Processing",

      // Steps Data
      scStep1Title: "Book Consultation",
      scStep1Desc: "Schedule a free consultation with our certified Schengen visa experts to assess your profile and destination strategy.",
      scStep2Title: "Document Preparation",
      scStep2Desc: "Our specialists prepare and verify every required document — financial proof, itinerary, hotel bookings, and insurance.",
      scStep3Title: "Embassy Appointment",
      scStep3Desc: "We secure your appointment slot at the earliest date and fully prepare you for your biometric interview.",
      scStep4Title: "Visa Approval",
      scStep4Desc: "Track your status in real-time. We follow up with the embassy directly and notify you as soon as your visa is ready.",

      // Documents Data
      scDoc1: "Valid Passport (Minimum 6 months validity remaining)",
      scDoc2: "Completed & Signed Schengen Visa Application Form",
      scDoc3: "Two Recent Photos (Biometric 35x45mm Standard)",
      scDoc4: "Confirmed Flight Reservation & Detailed Travel Itinerary",
      scDoc5: "Verifiable Hotel Booking or Host Invitation Letter",
      scDoc6: "Schengen Travel Insurance (Min. €30,000 coverage)",
      scDoc7: "Official Bank Statements (Last 3 to 6 Months)",
      scDoc8: "No Objection Certificate (NOC) from Employer / Sponsor",
      scDoc9: "Recent Salary Slips / Proof of Income",
      scDoc10: "Proof of Civil Status (Marriage / Family Certificate)",

      // FAQ Data
      scFaqQ1: "How long does it take to get a Schengen visa from Oman?",
      scFaqA1: "Processing typically takes 15 calendar days from the day of your embassy appointment. During peak travel seasons (May–August), it can take up to 30–45 days. We strongly recommend applying at least 6 to 8 weeks prior to travel.",
      scFaqQ2: "Which Schengen embassy should I apply to?",
      scFaqA2: "You must apply to the embassy of the country where you plan to spend the most days. If spending equal days in multiple countries, apply to the embassy of your first point of entry into the Schengen area.",
      scFaqQ3: "Can I obtain a multiple-entry Schengen visa?",
      scFaqA3: "Yes. Candidates with good travel histories, solid financial backing, and previous Schengen visas are eligible for 1 to 5-year multiple-entry visas. We explicitly tailor your application dossier to request extended validity.",
      scFaqQ4: "What is the success rate for Oman residents?",
      scFaqA4: "Oman residents with accurate documentation have a very high approval rate. Our agency maintains a 94%+ approval rate by ensuring zero errors in paperwork before submission.",

      // Country Names
      scCountryGermany: "Germany",
      scCountryFrance: "France",
      scCountryItaly: "Italy",
      scCountrySpain: "Spain",
      scCountryNetherlands: "Netherlands",
      scCountryAustria: "Austria",
      scCountrySwitzerland: "Switzerland",
      scCountryBelgium: "Belgium",
      scCountryPortugal: "Portugal",
      scCountryGreece: "Greece",
      scCountrySweden: "Sweden",
      scCountryDenmark: "Denmark",
      visaSupportService: "Visa Support Service",
      dtHeroLine1: "A verifiable flight reservation —",
      dtHeroLine2: "ready for your visa file",
      dtHeroSub: "Get a real, airline-issued PNR as proof of onward travel for your Schengen or embassy visa application — delivered by email within 30 minutes, no full ticket payment required.",
      reserveNow: "Reserve My Dummy Ticket",

      trustTicketLabel: "Official Airline PNR",
      trustClockLabel: "Delivered in 30 Mins",
      trustShieldLabel: "100% Embassy Accepted",
      trustGlobeLabel: "Schengen & Global Visas",

      // ── BOOKING FORM ──
      reserveYours: "Reserve Yours",
      dtFormTitle: "Request your dummy ticket",
      dtSideEyebrow: "Before You Submit",
      dtSideTitle: "A few things to have ready",
      dtSideText: "This speeds up issuing your reservation and avoids mismatches with your passport.",
      dtSidePoint1: "Full name exactly as on your passport",
      dtSidePoint2: "Passport number and nationality",
      dtSidePoint3: "Preferred travel dates",
      dtSidePoint4: "A valid email to receive your PDF",

      // Form Success
      dtSuccessTitle: "Request received",
      dtSuccessText: "Our team is preparing your reservation. You'll receive the itinerary by email shortly.",

      // Form Fields & Controls
      planOneWay: "One-Way",
      planRoundTrip: "Round-Trip",
      fullNamePassport: "Full Name (as per passport)",
      passportNumber: "Passport Number",
      nationality: "Nationality",
      nationalityPlaceholder: "e.g. Omani",
      numberOfTravelers: "Number of Travelers",
      departureCity: "Departure City",
      departureCityPlaceholder: "e.g. Muscat (MCT)",
      destinationCity: "Destination City",
      destinationCityPlaceholder: "e.g. Paris (CDG)",
      departureDate: "Departure Date",
      returnDate: "Return Date",
      email: "Email",
      whatsappPhone: "WhatsApp / Phone",
      additionalNotes: "Additional Notes (optional)",
      notesPlaceholder: "Embassy name, appointment date, or any special request",
      submitRequest: "Submit Request",

      // ── WHATSAPP STRIP ──
      dtWaTitle: "Need it within the hour?",
      dtWaText: "Message us on WhatsApp for urgent same-day reservations.",
      chatOnWhatsapp: "Chat on WhatsApp",

  "visaApplicationDesc": "Apply for your visa easily",
  "trackApplicationDesc": "Check your status in real-time",
  "schengenVisa": "Schengen Visa",
  "schengenVisaDesc": "Requirements & guidance",
  "dummyTicketDesc": "Flight itinerary for visa",
  "travelInsurance": "Travel Insurance",
  "travelInsuranceDesc": "Covered worldwide",

  "otherCountries": "Other Countries",
  "oman": "Oman",
  "visaForOman": "Electronic visa",
  "uae": "UAE",
  "visaForUae": "Dubai & Emirates",
  "saudiArabia": "Saudi Arabia",
  "visaForKsa": "Umrah & Tourism",
  "bahrain": "Bahrain",
  "visaForBahrain": "Fast processing",
  "kuwait": "Kuwait",
  "visaForKuwait": "Official processing",
  "qatar": "Qatar",
  "visaForQatar": "Hayya & Tourist",
  "thailand": "Thailand",
  "visaForThailand": "Tropical gateway",
  "india": "India",
  "visaForIndia": "e-Visa services",
  "armenia": "Armenia",
  "visaForArmenia": "Quick entry",
  "usa": "USA",
  "visaForUsa": "B1/B2 Visa support",
  "canada": "Canada",
  "visaForCanada": "Visitor visa guidance",

  "hot": "HOT",
  "myBookings": "My Bookings",
  "signOut": "Sign Out",

  "footerBrandTitle": "Silver Jarz Travel",
  "footerBrandDesc": "Your trusted travel partner for worldwide visas, custom tours, and premium car rentals.",
  
  "footerServicesTitle": "Our Services",
  "footerVisaServices": "Visa Services",
  "footerTourPackages": "Tour Packages",
  "footerCarRentals": "Car Rentals",
  "footerFlightBooking": "Flight Booking",

  "footerCompanyTitle": "Company",
  "footerAboutUs": "About Us",
  "footerBlog": "Blog",
  "footerFaq": "FAQs",

  "footerSupportTitle": "Support & Legal",
  "footerContactUs": "Contact Us",
  "footerPrivacyPolicy": "Privacy Policy",
  "footerTerms": "Terms & Conditions",
  "footerPaymentInfo": "Payment Info",
  "footerLegalDisclaimer": "Legal Disclaimer",

  // FAQ Page
faqEyebrow: "SUPPORT CENTER",
faqSubtitle: "Straight answers on visas, tours and car rental in Oman — from application documents to what happens if something goes wrong. Can't find it here? Our team is a message away.",
faqAllQuestions: "All Questions",
faqCategoryVisa: "Visa Services",
faqCategoryTravel: "Tours & Travel",
faqCategoryCar: "Car Rental",
faqCategoryGeneral: "Payments & Support",

// FAQ Visa Questions
faqVisaQ1: "Which visas can I apply for through Silver Jarz?",
faqVisaA1: "We handle tourist and visit visas for the Schengen area, the UAE, Saudi Arabia, Qatar, Bahrain, Kuwait, the UK, the USA, Canada, India, Thailand and Armenia, among others. If your destination isn't listed, ask us directly — we regularly add new routes based on demand.",
faqVisaQ2: "How long does visa processing take?",
faqVisaA2: "Most single-entry visas are processed in 3–5 business days once your file is complete. Multiple-entry and certain embassy-dependent visas can take up to 7 days. We'll give you a specific estimate for your destination and passport before you pay anything.",
faqVisaQ3: "What documents do I need to apply?",
faqVisaA3: "As a baseline: a passport valid for at least 6 months beyond your travel date, passport-size photos, proof of employment or income, and — depending on the destination — a hotel booking, flight reservation and travel insurance. Our team reviews your file before submission and tells you exactly what's missing, so you don't get rejected over a paperwork gap.",
faqVisaQ4: "What happens if my visa is refused?",
faqVisaA4: "It's rare — our approval rate sits around 98% because we screen applications before they reach the embassy — but if a refusal does happen, we review the reason with you, correct the file, and resubmit at no extra service fee where the refusal was linked to a fixable documentation issue. Embassy fees themselves are non-refundable, as with any visa application worldwide.",
faqVisaQ5: "Do you provide dummy tickets and travel insurance for the visa file?",
faqVisaA5: "Yes. Many embassies ask for a flight reservation and insurance certificate as part of the application, even before you've booked real flights. We issue both as add-ons so your visa file is complete on the first submission.",

// FAQ Travel Questions
faqTravelQ1: "Do you offer fixed packages, or can you build a custom trip?",
faqTravelA1: "Both. Our published packages (like the Musandam fjord cruises or the Muscat heritage trips) are ready to book as-is, but most clients ask us to adjust the duration, hotel category or add stops — tell us your dates and budget and we'll put together a custom itinerary.",
faqTravelQ2: "What's typically included in a tour package price?",
faqTravelA2: "Accommodation, private or shared transport, listed excursions and a local guide where relevant. Flights, meals outside the itinerary, and personal expenses are usually separate unless the package explicitly says 'all-inclusive.' We list exact inclusions on every package page before you book.",
faqTravelQ3: "Can you handle the visa and the trip together?",
faqTravelA3: "Yes — this is the most common request we get. Tell us your destination and travel dates, and we'll coordinate the visa timeline with your flights and hotel bookings so nothing is left to the last minute.",

// FAQ Car Questions
faqCarQ1: "What do I need to rent a car in Oman?",
faqCarA1: "A valid driving licence (an International Driving Permit alongside your home licence if it isn't in English or Arabic), a passport or Omani ID, and a refundable security deposit held on a card. Minimum renter age is generally 21, rising to 25 for larger SUVs and premium models.",
faqCarQ2: "Can I take a rental car across the border into the UAE?",
faqCarA2: "Cross-border trips are possible but need to be arranged in advance — we issue a cross-border permit and confirm your insurance covers UAE roads before you leave. Driving into a neighbouring country without this paperwork will void your insurance, so always flag it when booking.",
faqCarQ3: "Is insurance included in the rental price?",
faqCarA3: "Every rental includes basic third-party insurance by default. We also offer optional Collision Damage Waiver (CDW) and theft protection that reduce your liability to zero in the event of an incident — we'd recommend it for anyone unfamiliar with driving in Oman.",

// FAQ General Questions
faqGeneralQ1: "What payment methods do you accept?",
faqGeneralA1: "Cash, major debit/credit cards, and bank transfer. Visa and tour bookings typically need a deposit to lock in your dates, with the balance due before or on arrival — we'll confirm the exact split for your booking upfront.",
faqGeneralQ2: "Can I reach support while I'm already travelling?",
faqGeneralA2: "Yes — our support line is staffed 24/7 by phone and WhatsApp for exactly this reason. If a flight changes, a hotel issue comes up, or your visa status needs checking mid-trip, you're not left waiting on a Muscat office to open.",

// FAQ Beyond Section
faqBeyondEyebrow: "Beyond the FAQ",
faqBeyondTitle: "How We Actually Help",
faqBeyondSub: "The parts of the process that don't fit in a one-line answer.",

// FAQ Support Cards
faqSupport1Title: "Free Document Review",
faqSupport1Text: "Send us your documents before you commit to anything — we'll tell you honestly if your file is strong enough, and what to fix if it isn't.",
faqSupport2Title: "Real-Time Status Updates",
faqSupport2Text: "No guessing where your application stands — you get a status update as your visa moves through each stage, not just at submission and approval.",
faqSupport3Title: "One Point of Contact",
faqSupport3Text: "Whether it's a visa, a tour, or a rental car, you deal with the same team — no bouncing between departments to get one trip organised.",
faqSupport4Title: "14+ Years in Oman",
faqSupport4Text: "We've been arranging visas and trips out of Oman since 2010 — long enough to know which embassies are strict about what, and to plan around it.",
faqSupport5Title: "Arabic & English Support",
faqSupport5Text: "Our team works with you in whichever language you're most comfortable in, so nothing gets lost between what you need and what gets submitted.",
faqSupport6Title: "26,000+ Travellers Served",
faqSupport6Text: "From first-time Schengen applicants to repeat business travellers — the questions above come from cases we've actually handled, not a generic template.",

// FAQ CTA Section
faqCtaEyebrow: "Still Stuck?",
faqCtaTitle: "Ask us directly — no ticket queue",
faqCtaSub: "Message our team on WhatsApp or call the office. Most questions get a real answer within the hour during business hours, not an auto-reply.",
faqContactBtn: "Contact Us",
faqWhatsappBtn: "WhatsApp Us",

// Ticket Page - Request a Flight Ticket
ticketPageTitle: "Request your flight ticket",
ticketPageSubtitle: "Fill in your travel details below and our team will confirm your booking within 24 hours.",
ticketBreadcrumbHome: "Home",
ticketBreadcrumbTravel: "Travel",
ticketBreadcrumbCurrent: "Request a Ticket",
ticketCardTitle: "Flight Ticket Request",
ticketCardSubtitle: "Complete all sections · We'll contact you to confirm",

// Steps
ticketStep1: "Trip Details",
ticketStep2: "Passengers",
ticketStep3: "Contact",

// Trip Configuration
tripConfigTitle: "Trip Configuration",
tripTypeLabel: "Trip Type",
tripTypeRoundtrip: "Round Trip",
tripTypeOneway: "One Way",
tripTypeMulticity: "Multi-City",
routeTitle: "Route",
flyingFrom: "Flying From",
flyingFromPlaceholder: "City or airport (e.g. Madrid MAD)",
flyingTo: "Flying To",
flyingToPlaceholder: "City or airport (e.g. Paris CDG)",
viaStopover: "Via (stopover)",
viaPlaceholder: "Optional stopover city or airport",
dateFlexibility: "Date Flexibility",
dateFlexibilityExact: "Exact dates only",
dateFlexibility1Day: "± 1 day",
dateFlexibility3Days: "± 3 days",
dateFlexibility1Week: "± 1 week",
dateFlexibilityFlexible: "I'm fully flexible",
baggagePreference: "Baggage Preference",
baggage1Bag: "1 checked bag (up to 23kg)",
baggage2Bags: "2 checked bags (up to 23kg each)",
baggagePremium: "Premium baggage (32kg each)",
baggageCabinOnly: "Cabin luggage only",
preferredAirline: "Preferred Airline",
preferredAirlinePlaceholder: "Optional (e.g. Air France)",
continueToPassengers: "Continue to Passengers →",

// Passengers
passengersTitle: "Number of Passengers",
adults: "Adults",
adultsSub: "Age 18 and over",
children: "Children",
childrenSub: "Ages 2 – 17",
infants: "Infants",
infantsSub: "Under 2 years (lap)",
leadPassengerTitle: "Lead Passenger Details",
firstName: "First Name",
firstNamePlaceholder: "As on passport",
lastName: "Last Name",
lastNamePlaceholder: "As on passport",
passportNumberPlaceholder: "e.g. AB1234567",
passportExpiry: "Passport Expiry",
passportExpiryMonth: "Month",
passportExpiryYear: "Year",
specialRequests: "Special Requests",
specialRequestsPlaceholder: "e.g. wheelchair assistance, meal preference, seat preference (window/aisle)…",
back: "Back",

// Contact
emailPlaceholder: "your@email.com",
requestSummary: "Request Summary",
route: "Route",
departure: "Departure",
return: "Return",
passengers: "Passengers",
cabin: "Cabin",
baggage: "Baggage",
leadPassenger: "Lead Passenger",
termsConfirm: "I confirm that all provided information is accurate and I agree to the",
termsConditions: "Terms & Conditions",
and: "and",
submitting: "Submitting your request…",

// Success
requestSubmitted: "Request Submitted!",
requestSubmittedText: "Thank you. Your ticket request has been received. Our team will review your details and reach out within",
toConfirm: "to confirm your booking.",
reference: "Reference",
submitAnother: "Submit another request",

// Side Panel


ourGuarantees: "Our Guarantees",
guaranteeBestPrice: "Best price",
guaranteeFreeCancellation: "Free cancellation",
guaranteeSecurePayment: "Secure payment",
guaranteeSupport: "24/7 support",
guaranteeAirlines: "500+ airlines",
guaranteeETicket: "E-ticket",
needAssistance: "Need assistance?",
phone: "Phone",
hoursLabel: "Hours",
hoursValue: "Mon–Sun 8:00 – 20:00",

// Auth Modal
authRequired: "Authentication Required",
authRequiredText: "To request a flight ticket and access personalized travel deals, please sign in to your account.",
signInToContinue: "Sign In to Continue",
continueBrowsing: "Continue Browsing",

// Validation Errors
errorRequired: "This field is required.",
errorSelectFrom: "Please select a departure city or airport.",
errorSelectTo: "Please select an arrival city or airport.",
errorNameLetters: "Use letters only, 2–50 characters.",
errorSelectNationality: "Please select your nationality.",
errorPassportInvalid: "Enter a valid passport number (5–15 letters or digits).",
errorSelectMonth: "Select month.",
errorSelectYear: "Select year.",
errorEmailInvalid: "Enter a valid email address.",
errorPhoneInvalid: "Enter a valid phone number (7–16 digits, may start with +).",
errorPassportExpired: "Passport appears to be expired.",
errorAcceptTerms: "Please accept the Terms & Conditions to continue.",
errorCompleteFields: "Complete all required fields before continuing.",
errorDepartureDate: "Please select a departure date.",
errorReturnDate: "Please select a return date.",

// Car Rental Page
carRentalSeoTitle: "Car Rental — Coming Soon | SilverJarz",
carRentalSeoDescription: "SilverJarz is preparing flexible, premium car rental options in Oman. Leave your email to be notified when car rental bookings open.",
carRentalEyebrow: "Daily · Weekly · Monthly",
carRentalTitle: "Our",
carRentalTitleEm: "Rental Fleet",
carRentalSubtitle: "Flexible, well-maintained vehicles for every trip — reserve online and drive with confidence.",
carFilterAll: "All Cars",
carFilterAutomatic: "Automatic",
carFilterManual: "Manual",
daily: "Daily",
monthly: "Monthly",
yearly: "Yearly",
rate: "rate",
seats: "seats",
viewAndBook: "View & Book",
carError: "Unable to load the fleet right now. Please try again shortly.",
carEmpty: "No vehicles match this filter at the moment.",
promoModalTag: "Limited Time Offer",
promoModalTitle: "Save on your next",
promoModalTitleEm: "rental",
promoModalText: "Book directly through our fleet today and enjoy flexible daily, monthly, and yearly rates — with no hidden fees and free cancellation up to 24 hours before pickup.",
promoPerk1: "Well-maintained vehicles, fully insured",
promoPerk2: "Flexible daily, monthly & yearly rates",
promoPerk3: "Instant online booking, no paperwork",
promoBrowseBtn: "Browse the Fleet",
promoLaterBtn: "Maybe later",

// Car Rental Detail Page
day: "day",
month: "month",
year: "year",
linkCopied: "Link copied to clipboard!",
fileUnsupported: "Unsupported format (.pdf, .word, .jpeg, .jpg, .png only)",
bookingError: "Something went wrong. Please try again.",
extrasLabel: "Extras",
none: "none",
protectionLabel: "Protection",
fullProtection: "Full Protection",
basicProtection: "Basic",
perRental: "per rental",
vehicleNotFound: "We couldn't find this vehicle.",
backToFleet: "Back to fleet",
rentalFleet: "Rental Fleet",
reg: "Reg",
saved: "Saved",
save: "Save",
share: "Share",
currentlyUnavailable: "Currently Unavailable",
transmission: "Transmission",
engine: "Engine",
regYear: "Reg. Year",
pickupChecklist: "Your pick-up checklist",
arriveOnTime: "Arrive on time",
whatToBring: "What to bring",
refundableDeposit: "Refundable deposit",
arriveOnTimeText: "We only hold your vehicle at your allocated pick-up time — after that it may be released to another customer. Your pick-up time is",
on: "on",
bringPassport: "A passport or national ID card",
bringLicence: "All drivers' valid licence(s)",
bringCreditCard: "A credit card in the main driver's name, to hold the deposit",
depositText: "At pick-up, the main driver needs a refundable security deposit available on their credit card. Cash and debit cards aren't accepted.",
acceptedCards: "Accepted cards:",
acceptedCardsList: "Mastercard, Visa, Diners Club, American Express.",
rentalGuidelines: "Rental Guidelines & Instructions",
rentalGuidelinesText: "Please note the following requirements for a smooth rental experience:",
mandatoryDocs: "Mandatory Documents",
mandatoryDocsText: "Valid driver's license and identification documents.",
fuelLevel: "Fuel Level",
fuelLevelText: "Returned with the same fuel level as provided at pickup.",
supportText: "Assistance available 24/7 via our customer helpline.",
whenDoYouNeedIt: "When do you need it?",
pickYourDates: "Pick your dates and rental length",
startDate: "Start Date",
endDate: "End Date",
pickupTime: "Pick-up time",
numberOf: "Number of",
s: "s",
addExtras: "Add any extras?",
addExtrasSub: "Requested with the counter — pay for these at pick-up",
protectionTitle: "Protection, for peace of mind",
protectionSub: "Choose how you're covered if something goes wrong (Required)",
whatsCovered: "What's covered",
basic: "Basic",
includedNoCost: "Included, no extra cost",
selectProtection: "Please select a protection option.",
mainDriverDetails: "Main driver's details",
allFieldsMandatory: "All fields are mandatory",
invalidEmail: "Invalid email",
invalidPhone: "Invalid phone number",
addressPlaceholder: "Street, City, Country",
documentType: "Document Type",
identityCard: "Identity Card",
driversLicense: "Driver's License",
passport: "Passport",
other: "Other",
uploadDocument: "Upload document",
selected: "Selected",
acceptedFormats: "Accepted: PDF, Word (.doc/.docx), JPG, PNG",
notesOptional: "Notes (optional)",
reviewConfirm: "Review & confirm",
reviewSub: "Check everything looks right before you book",
vehicleDates: "Vehicle & dates",
vehicle: "Vehicle",
pickup: "Pick-up",
dropoff: "Drop-off",
length: "Length",
driver: "Driver",
name: "Name",
document: "Document",
extras: "Extras",
protection: "Protection",
basicIncluded: "Basic (included)",
payNow: "Pay now",
payAtPickup: "Pay at pick-up",
total: "Total",
nextExtras: "Next: Extras",
nextProtection: "Next: Protection",
nextDetails: "Next: Your details",
reviewBooking: "Review booking",
confirmBook: "Confirm & Book",
secureBooking: "Secure booking · No payment required now",
bookingFailed: "Booking Failed",
tryAgain: "Try Again",

// Extra items
extraDriver: "Additional driver",
extraDriverSub: "If you also want other people to drive",
extraChildseat: "Child seat",
extraChildseatSub: "For small children, roughly 1–3 years old",
extraBoosterseat: "Booster seat",
extraBoosterseatSub: "For bigger children, roughly 4–11 years old",
extraInfantseat: "Infant car seat",
extraInfantseatSub: "For babies up to about 1 year old",
extraGps: "GPS navigation",
extraGpsSub: "A satellite navigation device that provides directions",

// Protection rows
protectTheft: "Theft of car",
protectTheftBasic: "You pay the excess",
protectTheftFull: "Fully refunded",
protectBodywork: "Bodywork damage",
protectBodyworkBasic: "You pay up to the excess",
protectBodyworkFull: "Fully refunded",
protectOtherDamage: "Any other damage",
protectOtherDamageBasic: "You pay the full cost",
protectOtherDamageFull: "Fully refunded",
protectBreakdown: "Breakdown costs",
protectBreakdownBasic: "You pay the full cost",
protectBreakdownFull: "Fully refunded",
protectOtherCosts: "Other costs",
protectOtherCostsBasic: "You pay the full cost",
protectOtherCostsFull: "You pay the full cost",

// Steps
stepDates: "Dates",
stepExtras: "Extras",
stepProtection: "Protection",
stepDetails: "Your details",
stepReview: "Review",

// Perks
perk1: "Comprehensive insurance included",
perk2: "Free cancellation up to 24h before pickup",
perk3: "24/7 roadside assistance",
perk4: "Unlimited mileage",
perk5: "No hidden fees",


    },
  },
  ar: {
    translation: {
      // Header translations (existing)
      signIn: "تسجيل الدخول / التسجيل",
      dashboard: "لوحة التحكم",
      bookings: "حجوزاتي",
      settings: "إعدادات الحساب",
      logout: "تسجيل الخروج",
      allRightsReserved: "جميع الحقوق محفوظة",
      backToTop: "العودة إلى الأعلى",
      
      // Home page translations
      // Hero Section
      heroLabel1: "رحلات الصحراء · عمان",
      heroHeadline1_1: "رحلة إلى",
      heroHeadline1_2: "رمال عمان",
      heroHeadline1_3: "الذهبية",
      heroSub1: "كثبان لا نهاية لها، مخيمات تحت النجوم ومسارات بدوية قديمة تنتظرك في صحراء وهيبا.",
      heroCta1: "استكشف رحلات الصحراء",
      
      heroLabel2: "التراث والثقافة · مسقط",
      heroHeadline2_1: "اكتشف",
      heroHeadline2_2: "روح",
      heroHeadline2_3: "مسقط",
      heroSub2: "المساجد الكبرى، القلاع الملكية ورائحة اللبان ترشد رحلتك.",
      heroCta2: "استكشف مسقط",
      
      heroLabel3: "فخامة ساحلية · مسندم",
      heroHeadline3_1: "أبحر في",
      heroHeadline3_2: "خلجان",
      heroHeadline3_3: "مسندم",
      heroSub3: "خلجان كريستالية، سفن تقليدية وشعاب بكر حيث يلتقي البحر بالسماء.",
      heroCta3: "استكشف الرحلات البحرية",
      
      contactUs: "اتصل بنا",
      
      // Search Bar
      travelDates: "تواريخ السفر",
      destination: "الوجهة",
      tripType: "نوع الرحلة",
      destinationPlaceholder: "مسقط، صلالة، دبي…",
      allTypes: "جميع الأنواع",
      desertSafari: "رحلة صحراوية",
      culturalTour: "جولة ثقافية",
      coastalSea: "ساحلي وبحري",
      mountainTrek: "رحلات جبلية",
      
      // Stats
      destinationsCovered: "وجهة مغطاة",
      travellersServed: "مسافر تم خدمتهم",
      visaApprovalRate: "نسبة قبول التأشيرة",
      yearsOfExpertise: "سنوات من الخبرة",
      
      // Destinations
      exploreTheWorld: "استكشف العالم",
      premiumDestinations: "وجهات مميزة",
      handpickedEscapes: "وجهات مختارة بعناية في عمان والخليج وخارجها",
      viewAll: "عرض الكل",
      featured: "مميز",
      popular: "رائج",
      
      // Featured Trips
      curatedJourneys: "رحلات منسقة",
      featuredTrips: "رحلات مميزة",
      expertlyCrafted: "مسارات سياحية مصممة بخبرة لكل نوع من المغامرين",
      
      // Trip details
      from: "من",
      bookNow: "احجز الآن",
      topRated: "الأعلى تقييماً",
      bestSeller: "الأكثر مبيعاً",
      editorsPick: "اختيار المحرر",
      luxury: "فاخر",
      
      // How It Works
      simpleProcess: "عملية بسيطة",
      howItWorks: "كيف تعمل",
      step1Title: "ابحث عن تأشيرتك أو رحلتك",
      step1Text: "أدخل وجهتك وجنسيتك وتواريخ السفر للعثور على الخيارات المناسبة.",
      step2Title: "اختر باقة",
      step2Text: "اختر نوع التأشيرة أو باقة الرحلة التي تناسب جدولك وميزانيتك.",
      step3Title: "تقديم المستندات",
      step3Text: "قم بتحميل المستندات بأمان من خلال بوابة الإنترنت الموجهة في دقائق.",
      step4Title: "سافر بثقة",
      step4Text: "استلم تأكيد التأشيرة أو برنامج الرحلة وانطلق دون قلق.",
      
      // Why Choose Us
      ourStrengths: "نقاط قوتنا",
      whyChooseUs: "لماذا تختارنا",
      trustText: "موثوق من قبل آلاف المسافرين العمانيين منذ 2014",
      expertGuidesTitle: "مرشدون محليون خبراء",
      expertGuidesText: "يقدم متخصصونا العمانيون أصالة ثقافية حقيقية لكل تجربة.",
      endToEndTitle: "تخطيط متكامل",
      endToEndText: "التأشيرة، الرحلات الجوية، الفنادق، النقل والجولات — كلها تحت سقف واحد.",
      guaranteedApprovalsTitle: "موافقات مضمونة",
      guaranteedApprovalsText: "سجل موافقات تأشيرة بنسبة 98٪ مدعوم بأكثر من 10 سنوات من العلاقات مع السفارات.",
      support247Title: "دعم سفر على مدار الساعة",
      support247Text: "مساعدة على مدار الساعة قبل وأثناء وبعد رحلتك.",
      
      // Visa Pricing
      transparentPricing: "أسعار شفافة",
      visaPackages: "باقات التأشيرة",
      visaSubtitle: "خيارات مرنة مصممة لكل نوع من المسافرين من عمان",
      mostPopular: "الأكثر شهرة",
      singleEntry: "دخول فردي",
      multipleEntry: "دخول متعدد",
      serviceType: "نوع الخدمة",
      processingTime: "وقت المعالجة",
      useValidity: "صلاحية الاستخدام",
      stayValidity: "صلاحية الإقامة",
      applyNow: "قدم الآن",
      
      // Testimonials
      socialProof: "الدليل الاجتماعي",
      whatClientsSay: "ماذا يقول عملاؤنا",
      
      // Special Offers
      limitedTime: "لفترة محدودة",
      seasonalSpecialOffers: "عروض موسمية خاصة",
      specialOffersSub: "خطط مسبقاً واستفد من توفيرات كبيرة مع الحجز المبكر",
      
      // Common
      properties: "عقار",
      reviews: "تقييم",
      days: "أيام",
      hours: "ساعات",

      contact: "اتصل بنا",
contactTitle: "يسعدنا الاستماع إليك",
contactSubtitle: "تواصل معنا عبر أي من القنوات أدناه — فريقنا يرد بسرعة.",
whatsapp: "واتساب",
whatsappDesc: "أسرع رد",
startChat: "ابدأ المحادثة الآن",
callUs: "اتصل بنا",
available247: "متاح 24/7",
emailUs: "راسلنا بالبريد",
emailResponse: "نرد خلال ساعتين",
location: "الموقع",
viewOnMap: "عرض على الخريطة",
whatsapp247: "واتساب 24/7",
sendMessage: "أرسل لنا رسالة",
teamResponse: "فريقنا يرد خلال ساعتين",
fullName: "الاسم الكامل",
fullNamePlaceholder: "جون دو",
emailAddress: "البريد الإلكتروني",
phoneNumber: "رقم الهاتف",
phonePlaceholder: "+968 12345678",
subject: "الموضوع",
subjectPlaceholder: "كيف يمكننا مساعدتك؟",
yourMessage: "رسالتك",
messagePlaceholder: "أخبرنا عن رحلتك، أسئلتك أو طلباتك...",
sendMessageBtn: "إرسال الرسالة",
home: "الرئيسية",
visas: "التأشيرات",
schengen: "شينجن",
tours: "الجولات",
promotions: "العروض",
flights: "الرحلات الجوية",
carRental: "تأجير السيارات",
information: "معلومات",
visaApplication: "طلب التأشيرة",
trackApplication: "تتبع الطلب",
visaShengen: "تأشيرة شينجن",
dummyTicket: "تذكرة وهمية",
insurance: "تأمين",
faqTitle: "الأسئلة الشائعة",

// FAQ Questions & Answers
faqQ1: "ماذا أحتاج لاستئجار سيارة؟",
faqA1: "لوريم إيبسوم دولور سيت أميت، consectetur adipiscing elit، sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam، quis nostrud exercitation ullamco.",

faqQ2: "كم يجب أن يكون عمري لاستئجار سيارة؟",
faqA2: "لوريم إيبسوم دولور سيت أميت، consectetur adipiscing elit، sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam، quis nostrud exercitation ullamco.",

faqQ3: "هل يمكنني حجز سيارة لشخص آخر؟",
faqA3: "لوريم إيبسوم دولور سيت أميت، consectetur adipiscing elit، sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam، quis nostrud exercitation ullamco.",

faqQ4: "كيف أجد أفضل عرض لاستئجار سيارة؟",
faqA4: "لوريم إيبسوم دولور سيت أميت، consectetur adipiscing elit، sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam، quis nostrud exercitation ullamco.",

faqQ5: "ما الذي يجب أن أبحث عنه عند اختيار سيارة؟",
faqA5: "لوريم إيبسوم دولور سيت أميت، consectetur adipiscing elit، sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam، quis nostrud exercitation ullamco.",

// Help Block
helpTitle1: "حجز نشاطك",
helpText1: "لوريم إيبسوم هو نص تجريبي شائع الاستخدام في المواقع.",
helpTitle2: "الدفع والإيصالات",
helpText2: "لوريم إيبسوم هو نص تجريبي شائع الاستخدام في المواقع.",
helpTitle3: "تغييرات الحجز والاسترداد",
helpText3: "لوريم إيبسوم هو نص تجريبي شائع الاستخدام في المواقع.",
helpTitle4: "رموز العروض والائتمانات",
helpText4: "لوريم إيبسوم هو نص تجريبي شائع الاستخدام في المواقع.",
helpTitle5: "في يوم المشاركة",
helpText5: "لوريم إيبسوم هو نص تجريبي شائع الاستخدام في المواقع.",
helpTitle6: "باقات القيمة",
helpText6: "لوريم إيبسوم هو نص تجريبي شائع الاستخدام في المواقع.",

// About Page - Hero
silverJarzTravel: "الجرز الفضي للسياحة والسفر",
heroTitle1: "رحلتك،",
heroTitle2: "مخططة بشكل مثالي.",
heroDescription: "بفضل سنوات من الخبرة في منطقة الخليج والعالم العربي، نجعل السفر سهلاً — من التأشيرات إلى باقات العطلات وكل ما بينهما.",

// About Page - About Us
aboutUs: "من نحن",
aboutHeadline1: "نضع راحتك",
aboutHeadline2: "فوق كل شيء آخر.",
aboutText1: "في <strong style='color: var(--teal); font-weight: 600;'>الجرز الفضي للسياحة والسفر</strong>، راحتك تأتي أولاً. بفضل سنوات من الخبرة في صناعة السفر والسياحة، نقدم حلولاً متكاملة تشمل التأشيرات، تذاكر الطيران، التأمين، وباقات العطلات المصممة خصيصاً.",
aboutText2: "سواء كنت تخطط لرحلة عمل أو عطلة عائلية، فريقنا ملتزم بتقديم تجارب سفر سلسة لا تُنسى في جميع أنحاء منطقة الخليج والعالم العربي.",
badgeYears: "١٢+",
badgeText: "سنوات من التميز\nفي السفر والسياحة",
flightTickets: "تذاكر طيران",
holidayPackages: "باقات عطلات",

// About Page - Mission & Vision
ourPurpose: "هدفنا",
purposeHeadline1: "مدفوعون بالمهمة،",
purposeHeadline2: "موجهون بالرؤية.",
ourMission: "مهمتنا",
missionTitle: "خدمات عالية الجودة بأسعار تنافسية",
missionText: "تقديم خدمات سفر عالية الجودة بأسعار تنافسية مع الالتزام الكامل بالشفافية والسرعة — لضمان حصول كل عميل على ما يحتاجه بالضبط، عندما يحتاجه.",
ourVision: "رؤيتنا",
visionTitle: "الخيار الأول في منطقة الخليج والعالم العربي",
visionText: "أن نصبح الخيار الأول للعملاء في منطقة الخليج والعالم العربي لجميع خدمات السفر والسياحة — من خلال الابتكار والثقة والرعاية المتميزة للعملاء.",

// About Page - Values
ourValues: "قيمنا",
valuesHeadline1: "المبادئ التي",
valuesHeadline2: "توجه كل ما نقوم به.",
valueTitle1: "النزاهة والشفافية",
valueDesc1: "نعمل بصدق تام في كل تفاعل، حتى تعرف دائماً بالضبط ما تحصل عليه.",
valueTitle2: "خدمة سريعة وموثوقة",
valueDesc2: "السرعة مهمة عند التخطيط لرحلة. نقدم حلولاً سريعة وموثوقة في كل مرة.",
valueTitle3: "دعم العملاء 24/7",
valueDesc3: "فريقنا المتفاني متاح دائماً، بغض النظر عن منطقتك الزمنية أو وجهة سفرك.",
valueTitle4: "حلول مبتكرة مخصصة",
valueDesc4: "كل مسافر فريد من نوعه. نصمم باقات شخصية تناسب احتياجاتك تماماً.",

// About Page - Why Us
whyUs: "لماذا نحن",
whyHeadline1: "لماذا يختار المسافرون",
whyHeadline2: "الجرز الفضي",

// About Page - Testimonials
testimonials: "شهادات العملاء",
testimonialsHeadline1: "ما يقوله",
testimonialsHeadline2: "عملاؤنا السعداء",
// Add to ar.translation object:

backToHome: "العودة إلى الرئيسية",
legalNotice: "إشعار قانوني",
termsTitle: "الشروط والأحكام",
termsSubtitle: "آخر تحديث: يناير ٢٠٢٦",
introduction: "مقدمة",
general: "عام",
termsIntro1: "تحكم هذه الشروط والأحكام استخدامك لموقع silverjarz.com. من خلال الوصول إلى الموقع واستخدامه، يوافق المستخدم على الالتزام بالشروط والأحكام الواردة في هذا الإشعار القانوني.",
termsIntro2: "تنطبق المصطلحات التالية على هذه الشروط والأحكام وبيان الخصوصية وإشعار إخلاء المسؤولية وجميع الاتفاقيات: تشير كلمات 'العميل' و'أنت' و'الخاص بك' إليك أنت، أي الشخص الذي يسجل الدخول إلى هذا الموقع الإلكتروني ويوافق على شروط وأحكام الشركة. تشير عبارات 'الشركة' و'نحن' و'لنا' و'نا' إلى شركتنا. تشير عبارات 'الطرف' و'الأطراف' و'نا' إلى كل من العميل ونحن.",
termsIntro3: "تشير جميع الشروط إلى العرض والقبول والنظر في الدفع اللازم للقيام بعملية تقديم المساعدة للعميل بالطريقة الأنسب للغرض الصريح المتمثل في تلبية احتياجات العميل فيما يتعلق بتوفير الخدمات المعلنة للشركة، وفقًا للقانون الساري في عمان عمان وخاضعًا له.",
changesToTerms: "التغييرات على الشروط",
updated: "محدث",
changesText1: "تحتفظ silverjarz.com بالحق في تغيير أو تعديل أو إضافة أو حذف أجزاء من هذه الشروط والأحكام أو كلها من وقت لآخر. تصبح التغييرات التي تطرأ على هذه الشروط والأحكام سارية المفعول فور نشرها على هذا الموقع الإلكتروني.",
changesText2: "يجب على المستخدم مراجعة هذه الشروط والأحكام بشكل دوري على الموقع الإلكتروني للتحقق من وجود أي تغييرات أو تحديثات. سيُعتبر استمرار المستخدم في استخدام هذا الموقع الإلكتروني بعد نشر التغييرات أو التحديثات بمثابة إخطار بموافقة المستخدم على الالتزام بهذه الشروط والأحكام والالتزام بها، بما في ذلك هذه التغييرات أو التحديثات.",
important: "⚠️ مهم:",
changesText3: "استخدام خدمات هذا الموقع دون قراءة الشروط والأحكام يعتبر إهمالاً من جانب المستخدم، وأي إزعاج ينشأ لاحقاً يقع تحت مسؤولية المستخدم.",
processingTimes: "أوقات المعالجة",
timing: "التوقيت",
expressProcessing: "معالجة التأشيرة السريعة",
expressText: "وقت معالجة التأشيرة السريعة المذكور في أي مكان على الموقع الإلكتروني هو 24 ساعة عمل.",
expressRefund: "إذا لم تتم الموافقة على تأشيرتك السريعة في غضون 24 ساعة عمل، فسوف يتم رد التكلفة الإضافية التي تم تحصيلها مقابل الخيار السريع.",
standardProcessing: "المعالجة القياسية",
standardText: "وقت الموافقة المذكور في أي مكان على الموقع الإلكتروني هو الوقت القياسي من قسم الهجرة. في حالات نادرة، قد يستغرق الحصول على الموافقة وقتًا أطول.",
timezoneInfo: "الإطار الزمني المذكور على الموقع الإلكتروني هو وفقًا لتوقيت الخليج القياسي، وتبدأ ساعات العمل في الساعة 8:00 صباحًا بتوقيت الخليج القياسي.",
holidayInfo: "السبت والأحد هما يومان عطلة بالنسبة لإدارة الهجرة. حتى إذا تقدم العميل بطلب للحصول على تأشيرة سريعة يوم الجمعة، فإن إدارة الهجرة لن تبدأ الإجراءات إلا يوم الاثنين من الساعة 8 صباحًا بتوقيت غرينتش.",
documentsInfo: "لا تُقبل وثائق السفر لطلبات الحصول على تأشيرة عمان. يُسمح فقط بجوازات السفر العادية.",
liability: "المسؤولية",
disclaimer: "إخلاء مسؤولية",
liabilityText: "لن تتحمل silverjarz.com أي مسؤولية في حالة تعطل سفرك بسبب أي نوع من أنواع إلغاء الحجز الفندقي أو إلغاء الرحلة الجوية.",
privacyPolicy: "سياسة الخصوصية",
dataProtection: "حماية البيانات",
privacyText1: "تبيع silverjarz.com تأشيرات عمان عبر الإنترنت. سيتم الاحتفاظ بالمعلومات الخاصة المطلوبة لتنفيذ الطلبات المقدمة من خلال خدمة التجارة الإلكترونية، وهي المعلومات الشخصية للمستخدم وتفاصيل بطاقة الائتمان وأرقام الهواتف، في سرية تامة ولن يتم بيعها أو إفشاؤها لأطراف ثالثة.",
creditCard: "🔒 معلومات بطاقة الائتمان:",
creditCardText: "لا تحتفظ silverjarz.com بتفاصيل بطاقة الائتمان تحت أي ظرف من الظروف.",
privacyText2: "إن وصولك إلى موقعنا الإلكتروني واستخدامه يتوقفان أيضًا على موافقتك على سياسة الخصوصية الخاصة بالشركة وامتثالك لها. بالموافقة على الشروط والأحكام، فإنك ملزم بإفصاح المعلومات التالية لنا. نحن نجمع الاسم وعنوان البريد الإلكتروني ورقم الهاتف المحمول وتفاصيل جواز السفر والصورة الفوتوغرافية وبلد الإقامة/الجنسية.",
privacyText3: "قد يتم استخدام المعلومات التي تم جمعها لتخصيص منتجاتنا وخدماتنا وعروضنا والترويج لها والإعلان عنها و/أو للتواصل معك.",
pricingPolicy: "سياسة الأسعار",
pricing: "التسعير",
pricingText1: "تحتفظ الشركة بالحق في تعديل أسعارها في أي وقت قبل قبول الطلب.",
pricingText2: "قد تقوم الشركة بمراجعة الأسعار المقتبسة بعد استلام الطلب في حالة حدوث أي ظرف يؤثر على التسليم بسبب إجراءات حكومية أو ارتفاع تكاليف صرف العملات الأجنبية أو أي أمر آخر خارج عن سيطرة الشركة.",
paymentPolicy: "سياسة الدفع",
payment: "الدفع",
paymentText1: "يمكن الدفع من خلال طرق الدفع المتاحة المختلفة، مثل Visa أو MasterCard.",
paymentText2: "تخضع بطاقات الدفع (بطاقات الائتمان أو الخصم) لعمليات التحقق من الصحة والتفويض من قبل جهة إصدار بطاقتك. إذا لم نتلق التفويض المطلوب، فلن نتحمل أي مسؤولية عن أي تأخير أو عدم تسليم طلبك.",
refundPolicy: "سياسة الاسترداد",
refunds: "المبالغ المستردة",
refundText1: "تخضع الموافقة على التأشيرة تمامًا لتقدير مسؤولي الهجرة.",
refundText2: "لا تتحمل silverjarz.com أي مسؤولية عن رفض أي طلبات تأشيرة.",
refundText3: "بمجرد تقديم طلب التأشيرة، سيتم معالجته على الفور.",
refundText4: "رسوم طلب التأشيرة غير قابلة للاسترداد في حالة رفضها من قبل إدارة الهجرة.",
refundText5: "في حالة طلب الإلغاء أو استرداد المبلغ، يرجى ملاحظة أن هذه الطلبات لا تُقبل إلا إذا تم تقديمها في غضون 3 ساعات من الدفع وقبل بدء معالجة الطلب. وسيتم خصم رسوم خدمة غير قابلة للاسترداد بنسبة 6.7% من المبلغ الإجمالي. أما الرصيد المتبقي فسيتم التعامل معه وفقًا لشروط الإلغاء المحددة من قبل مقدمي الخدمة.",
expressRefundPolicy: "سياسة استرداد الأموال لطلبات التأشيرات العاجلة",
express: "عاجل",
expressRefundTitle: "📋 استرداد المعالجة السريعة:",
expressRefundText1: "إذا كنت قد تقدمت بطلب للحصول على تأشيرة الإمارات السريعة ولم تتم معالجة طلبك في غضون 36 ساعة، فستكون مؤهلاً لاسترداد رسوم المعالجة السريعة (50 دولارًا أمريكيًا).",
expressRefundText2: "يرجى ملاحظة أن هذا الاسترداد ينطبق فقط على رسوم المعالجة العاجلة ولا يشمل رسوم طلب التأشيرة القياسية.",
expressRefundContact: "لطلبات استرداد الأموال، يرجى الاتصال بفريق الدعم لدينا مع ذكر رقم طلبك.",
termsFooter: "© ٢٠٢٦ silverjarz.com - جميع الحقوق محفوظة. تخضع هذه الشروط والأحكام لقوانين دولة عمان.",

// Add to ar.translation:

// Footer translations
company: "الشركة",
support: "الدعم",
otherServices: "خدمات أخرى",
blog: "المدونة",
faq: "الأسئلة الشائعة",
termsAndConditions: "الشروط والأحكام",
carHire: "تأجير السيارات",
activityFinder: "البحث عن الأنشطة",
tourList: "قائمة الجولات",
flightFinder: "البحث عن الرحلات",
cruiseTicket: "تذاكر الرحلات البحرية",
holidayRental: "إيجار العطلات",
travelAgents: "وكلاء السفر",

// Payment Guidelines - Arabic
paymentGuidelines: "إرشادات الدفع",
paymentTitle: "إرشادات الدفع – التأشيرة الإلكترونية لدولة عمان",
paymentSubtitle: "مرحبًا بكم في silverjarz.com، شريككم الموثوق لخدمات التأشيرة الإلكترونية إلى عمان. يرجى قراءة المعلومات التالية بعناية قبل متابعة عملية الدفع.",
whatsIncluded: "ما الذي يشمله المبلغ المدفوع",
coverage: "التغطية",
whatsIncludedIntro: "عند التقدم بطلب للحصول على تأشيرة إلكترونية لدولة عمان من خلال نظامنا، تغطي التكلفة الإجمالية ما يلي:",
included1: "رسوم المعالجة والدعم – لمعالجة طلبك وتقديم التوجيهات.",
included2: "الرسوم الحكومية والإدارية في عمان – الرسوم الرسمية للموافقة المسبقة على التأشيرة.",
transparent: "✅ أسعار شفافة:",
transparentText: "تضمن أسعارنا الشفافة أنك تفهم بالضبط ما يشمله المبلغ الذي تدفعه.",
paymentOptions: "خيارات الدفع المقبولة",
secure: "آمن",
paymentOptionsIntro: "نحن نقدم خدمة دفع سريعة ومشفرة عبر الإنترنت باستخدام بطاقات الائتمان والخصم الرئيسية:",
visaCard: "ائتمان/خصم",
mastercard: "ائتمان/خصم",
amex: "بطاقة ائتمان",
applePay: "دفع عبر الجوال",
googlePay: "دفع عبر الجوال",
importantNotes: "يرجى ملاحظة ما يلي:",
paymentNote1: "تتم معالجة جميع المدفوعات بالدولار الأمريكي (USD)",
paymentNote2: "ستظهر المعاملات في كشف حسابك على النحو التالي: SilverJarz trading contracting",
paymentNote3: "سيُطلب منك إدخال اسم حامل البطاقة وعنوان الفواتير ورقم البطاقة وتاريخ انتهاء الصلاحية ورمز CVV",
paymentNote4: "قد يكون رمز الأمان ثلاثي الأبعاد (OTP من البنك الذي تتعامل معه) مطلوبًا",
security: "🔒 الأمان:",
securityText: "نحن نحمي بياناتك باستخدام تشفير TLS ونتبع معايير PCI DSS لضمان أمان المعاملات.",
paymentResults: "نتائج الدفع",
outcome: "النتيجة",
successTitle: "✅ الدفع الناجح:",
successText: "ستظهر رسالة تأكيد على الشاشة. سيتم إرسال رسالة تأكيد عبر البريد الإلكتروني إليك بعد قليل.",
failTitle: "❌ فشل الدفع:",
failText: "ستظهر رسالة توضح سبب الفشل.",
importantNote: "⚠️ ملاحظة مهمة:",
importantNoteText: "جميع الرسوم بالدولار الأمريكي (USD).",
needHelp: "هل تحتاج إلى مساعدة؟",
needHelpText: "فريق خدمة العملاء لدينا متاح على مدار الساعة طوال أيام الأسبوع لمساعدتك في الأمور المتعلقة بالدفع أو أي أسئلة حول طلب التأشيرة.",
contactSupport: "اتصل بالدعم",
contactSupportText: "تواصل عبر واتساب أو الهاتف أو البريد الإلكتروني للحصول على مساعدة فورية.",
provideOrder: "قدم تفاصيل الطلب",
provideOrderText: "احضر رقم طلبك ومرجع الدفع للحصول على خدمة أسرع.",
resolveIssue: "حل المشكلات",
resolveIssueText: "سيعمل فريقنا معك لحل أي مشكلات تتعلق بالدفع أو الطلب.",
confirmation: "التأكيد",
confirmationText: "ستتلقى تأكيدًا بمجرد حل مشكلتك.",
readyToApply: "هل أنت مستعد للتقديم؟",
readyToApplyText: "ابدأ عملية تقديم طلب التأشيرة الإلكترونية لدولة عمان اليوم.",
applyNowBtn: "قدم الآن",
paymentInstructions:"إرشادات الدفع",
// Privacy Policy - Arabic
privacyPolicyLabel: "سياسة الخصوصية",
privacyTitle: "سياسة الخصوصية",
privacySubtitle: "آخر تحديث: يناير ٢٠٢٦",
companyInfo: "معلومات الشركة",
companyInfoText: "تصف سياسة الخصوصية هذه كيفية قيام SilverJarz trading contracting (\"نحن\" أو \"لنا\" أو \"بنا\") بجمع معلوماتك الشخصية واستخدامها وحمايتها عند استخدامك للخدمات المقدمة على https://silverjarz.com",
companyInfoText2: "silverjarz.com هي منصة خدمات مملوكة ومدارة من قبل SilverJarz trading contracting، وهي شركة سياحية مرخصة مقرها في دبي، عمان (رقم الترخيص 2644940.01). يعمل هذا الموقع كجزء رسمي من خدماتنا، ويركز على مساعدة الأفراد في طلبات تأشيرات زيارة عمان والخدمات السياحية ذات الصلة.",
consentText: "باستخدام هذا الموقع وخدماتنا، فإنك توافق على جمع واستخدام معلوماتك الشخصية وفقًا لسياسة الخصوصية هذه.",
purposeTitle: "الغرض من جمع البيانات",
dataCollection: "جمع البيانات",
purposeText: "الغرض الأساسي من جمع بياناتك الشخصية هو تزويدك بخدماتنا المتعلقة بما يلي:",
purpose1: "المساعدة في طلب تأشيرة زيارة عمان",
purpose2: "حزم الرحلات السياحية وحجوزات العطلات",
purpose3: "دعم العملاء والمتابعة",
purposeHighlight: "نحن نجمع فقط البيانات الضرورية لتقديم هذه الخدمات بفعالية والامتثال للمتطلبات القانونية.",
infoTypesTitle: "نوع المعلومات التي يتم جمعها",
infoTypesText: "لتزويدك بخدمات مخصصة وفعالة، نقوم بجمع البيانات الشخصية والتقنية اللازمة لمعالجة طلبات التأشيرة، وتحسين الخدمات، والامتثال للمتطلبات القانونية.",
personalInfo: "المعلومات الشخصية",
personalInfoText: "تشمل اسمك وعنوان بريدك الإلكتروني ورقم هاتفك وغيرها من المعلومات الأساسية المهمة لمعالجة طلبات التأشيرة والمعاملات الحكومية ذات الصلة.",
technicalData: "البيانات التقنية",
technicalDataText: "تتضمن معلومات مثل عنوان IP الخاص بك ونوع المتصفح ونظام التشغيل وسجلات الوصول، مما يساعدنا على فهم سلوك المستخدم وتحسين أداء الموقع الإلكتروني.",
cookiesText: "نحن نستخدم ملفات تعريف الارتباط وتقنيات التتبع المماثلة لتخصيص تجربتك وتحليل حركة المرور على الموقع. ملفات تعريف الارتباط هي في الواقع ملفات صغيرة مخزنة على جهازك تساعد في تنظيم الزوار المتكررين أو تذكر التفضيلات.",
howWeUseTitle: "كيف نستخدم معلوماتك",
usage: "الاستخدام",
use1: "معلوماتك الشخصية مهمة جدًا لتسهيل طلبات الحصول على التأشيرات أو الخدمات الحكومية الأخرى.",
use2: "نستخدم معلوماتنا للرد على الاستفسارات وتقديم المساعدة وتحسين خدمات الدعم التي نقدمها.",
use3: "نقوم بتحليل البيانات الفنية التي تسمح لنا بتحسين وظائف الموقع الإلكتروني وضمان تجربة مستخدم متماثلة.",
use4: "قد نقوم بمعالجة بياناتك لتتوافق مع الالتزامات القانونية والتنظيمية.",
storageTitle: "تخزين البيانات والاحتفاظ بها",
retention: "الاحتفاظ",
storageText: "يتم تخزين بياناتك بشكل آمن على خوادم محمية ويقتصر الوصول إليها على الموظفين المصرح لهم فقط. نحتفظ ببياناتك الشخصية طالما كان ذلك ضروريًا من أجل:",
storage1: "تنفيذ الخدمات التي طلبتها",
storage2: "الوفاء بالالتزامات القانونية أو المتعلقة بالامتثال",
storageHighlight: "نحتفظ بالبيانات الشخصية إلى أن نحتاجها، وفقًا لما يقتضيه قانون عمان، وبعد ذلك يتم حذفها أو إخفاء هويتها بشكل آمن.",
sharingTitle: "مشاركة البيانات والكشف عنها",
disclosure: "الإفصاح",
noSell: "🚫 نحن لا نبيع أو نؤجر معلوماتك الشخصية لأي طرف ثالث.",
sharingText: "قد يتم مشاركة بياناتك مع:",
share1: "الإدارات الحكومية الإماراتية المعنية بمعالجة التأشيرات",
share2: "شركاء معالجة الدفع (على سبيل المثال، Stripe)",
share3: "شركاء موثوقون في مجال الرحلات والخدمات بموجب اتفاقيات السرية",
share4: "السلطات القانونية عندما يقتضي ذلك قانون دولة  عمان",
cookiesTitle: "ملفات تعريف الارتباط وتقنيات التتبع",
tracking: "التتبع",
cookiesText2: "يستخدم موقعنا الإلكتروني ملفات تعريف الارتباط لتحسين تجربة التصفح وتحليل الاستخدام. تساعدنا ملفات تعريف الارتباط في:",
cookie1: "تذكر تفضيلاتك",
cookie2: "تحسين الأداء وتجربة المستخدم",
cookie3: "جمع إحصاءات مجهولة عن الزوار (على سبيل المثال، عبر Google Analytics)",
cookieOptOut: "يمكنك اختيار تعطيل ملفات تعريف الارتباط في إعدادات المتصفح، ولكن هذا قد يؤثر على بعض ميزات الموقع.",
clarityTitle: "مايكروسوفت كلاريتي",
analytics: "التحليلات",
clarityText: "نحن نستخدم Microsoft Clarity لفهم كيفية تفاعل المستخدمين مع موقعنا الإلكتروني بشكل أفضل ولتحسين تجربتهم بشكل عام. يلتقط Clarity سلوك المستخدمين مثل النقرات والتمرير وحركات الماوس من خلال تسجيلات الجلسات المجهولة الهوية وخرائط الحرارة.",
clarityText2: "قد يستخدم Clarity ملفات تعريف الارتباط وتقنيات التتبع الأخرى لهذا الغرض. جميع البيانات التي يتم جمعها مجهولة الهوية ولا تتضمن معلومات شخصية.",
clarityConsent: "باستخدام موقعنا الإلكتروني، فإنك توافق على معالجة بياناتك بواسطة Microsoft Clarity وفقًا لبيان خصوصية Microsoft.",
rightsTitle: "حقوقك وخياراتك",
yourRights: "حقوقك",
rightsText: "لديك حقوق محددة فيما يتعلق ببياناتك الشخصية. يمكنك طلب الوصول إلى معلوماتك الشخصية وتحديثها وتصحيحها حسب الاقتضاء.",
right1: "يمكنك طلب حذف معلوماتك الشخصية وفقًا للالتزامات القانونية والتعاقدية.",
right2: "يمكنك إلغاء الاشتراك في تلقي رسائلنا التسويقية في أي وقت.",
rightsContact: "لممارسة أي من هذه الحقوق، يرجى الاتصال بفريق الدعم لدينا.",
securityTitle: "أمن البيانات",
security2: "الأمان",
externalLinksTitle: "روابط خارجية",
links: "الروابط",
externalLinksText: "قد يحتوي موقعنا الإلكتروني على روابط لمواقع إلكترونية تابعة لأطراف ثالثة. لا تنطبق سياسة الخصوصية هذه على تلك المواقع الإلكترونية، ونحن غير مسؤولين عن محتواها أو ممارساتها في التعامل مع البيانات.",
updatesTitle: "تحديثات السياسة",
updates: "التحديثات",
updatesText: "قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سيتم نشر أي تغييرات على هذه الصفحة مع تاريخ سريان محدّث. يرجى مراجعة هذه الصفحة بانتظام للبقاء على اطلاع.",
disclaimerTitle: "إخلاء المسؤولية",
disclaimer2: "إخلاء المسؤولية",
disclaimerText: "نحن مزود خدمات استشارية وتسهيلية من القطاع الخاص، تديره شركة SilverJarz trading contracting، وهي شركة سياحية مرخصة مقرها في دبي، عمان (رقم الترخيص 2644940.01) لطلبات التأشيرات. نحن لسنا تابعين لأي نوع من أنواع الحكومات ولا نملك سلطة الموافقة على طلبات التأشيرة أو رفضها.",
disclaimerText2: "باستخدام موقعنا الإلكتروني وخدماتنا، فإنك تقر وتوافق على الشروط الموضحة في سياسة الخصوصية هذه. ثقتك مهمة جدًا بالنسبة لنا، ونحن ملتزمون بحماية معلوماتك الشخصية بأفضل عناية ممكنة. نسعى جاهدين لجعل عملية طلب التأشيرة سلسة وآمنة.",
commitment: "✅ التزامنا:",
commitmentText: "التزامنا تجاه الخصوصية يضمن التعامل مع معلوماتك الشخصية وفقًا لأعلى معايير الأمان والسرية. يجب أن تكون Trust شريكًا موثوقًا في التعامل مع تعقيدات طلبات التأشيرات، حيث توفر لك إرشادات الخبراء وتدعمك في كل خطوة على الطريق.",

legalDisclaimerLabel: "إخلاء المسؤولية القانونية",
legalDisclaimerTitle: "إخلاء المسؤولية القانونية",
legalDisclaimerSubtitle: "آخر تحديث: يناير ٢٠٢٦",
disclaimerCompanyInfo: "معلومات الشركة",
disclaimerCompanyText: "هذا الموقع الإلكتروني، silverjaz.com، مملوك ومدار من قبل SilverJarz trading contracting (رقم الترخيص 2404940.01). نحن وكالة خاصة ومستقلة متخصصة في استشارات السفر ودعم توثيق تأشيرات عمان.",
disclaimerImportant: "⚠️ إشعار مهم:",
disclaimerMain: "يرجى العلم أن silverjarz.com هو كيان غير حكومي ولا يرتبط بحكومة عمان أو أي سلطة رسمية للهجرة ولا يحظى بتأييدها. تترتب على خدماتنا المهنية رسوم خدمة منفصلة عن الرسوم الحكومية الإلزامية.",
keyPointsTitle: "نقاط رئيسية للفهم",
privateAgency: "وكالة خاصة",
privateAgencyText: "نحن مزود خدمات استشارية وتسهيلية من القطاع الخاص، وليس كيانًا حكوميًا.",
serviceFees: "رسوم الخدمة",
serviceFeesText: "تترتب على خدماتنا المهنية رسوم خدمة منفصلة عن رسوم التأشيرة الحكومية الإلزامية.",
governmentOption: "خيار الحكومة",
governmentOptionText: "يمكن للأفراد الذين يرغبون في التقدم بطلب للحصول على تأشيرة بشكل مستقل القيام بذلك عبر البوابات الحكومية الرسمية بتكلفة مخفضة.",
facilitationOnly: "تسهيل فقط",
facilitationOnlyText: "نساعد في تسهيل الإجراءات الإدارية لوثائق السفر ولكننا لا نتخذ قرارات الموافقة.",
detailedInfo: "معلومات مفصلة",
details: "التفاصيل",
entityType: "نوع الكيان:",
entityTypeText: "شركة خاصة محدودة مسجلة في، عمان",
license: "الترخيص:",
licenseText: "SilverJarz trading contracting - رقم الترخيص 2404940.01",
affiliation: "التبعية:",
affiliationText: "مستقل - غير تابع لأي كيان حكومي",
services: "الخدمات:",
servicesText: "استشارات السفر ودعم توثيق تأشيرات عمان",
summaryTitle: "الملخص",
recap: "الخلاصة",
summaryText: "باستخدام هذا الموقع، فإنك تقر بأننا مزود خدمة خاص يساعد في تسهيل الإجراءات الإدارية لوثائق السفر. ليس لدينا سلطة الموافقة على طلبات التأشيرة أو رفضها، وخدماتنا منفصلة عن العمليات الحكومية.",
disclaimerFooter: "© ٢٠٢٦ silverjarz.com - جميع الحقوق محفوظة. SilverJarz trading contracting",
// ── VISA TRANSLATIONS (AR) ──
visaValidationAlert: "يرجى تحديد وجهة السفر والجنسية.",
visaEyebrow: "خدمات التأشيرة حول العالم",
visaHeroTitle1: "رحلتك تبدأ مع",
visaHeroTitle2: "التأشيرة",
visaHeroTitleWord: "المناسبة",
visaHeroSubtitle: "توجيهات متخصصة وإجراءات سلسة لأكثر من 190 وجهة حول العالم.",
visaTrustBadge: "موثوق به من قبل أكثر من 50,000 مسافر",
visaDestinationLabel: "الوجهة",
visaDestinationPlaceholder: "إلى أين أنت ذاهب؟",
visaNationalityLabel: "الجنسية",
visaNationalityPlaceholder: "بلد جواز سفرك",
visaLivingInLabel: "بلد الإقامة",
visaLivingInPlaceholder: "مكان إقامتك الحالي",
visaFindBtn: "البحث عن تأشيرة",
visaLoading: "جاري التحميل...",
visaStepsEyebrow: "خطوات بسيطة",
visaStepsTitle: "كيف تعمل الخدمة",
visaStepsSubtitle: "احصل على تأشيرتك في 4 خطوات بسيطة دون عناء المعاملات الورقية.",
visaStep1Title: "اختر الوجهة",
visaStep1Desc: "اختر وجهة سفرك وجنسيتك للاطلاع على خيارات التأشيرة المتاحة.",
visaStep2Title: "رفع المستندات",
visaStep2Desc: "قم بملء الطلب عبر الإنترنت ورفع المستندات المطلوبة بأمان.",
visaStep3Title: "الدفع عبر الإنترنت",
visaStep3Desc: "أكمل عملية الدفع باستخدام بوابات الدفع الآمنة والمشفرة.",
visaStep4Title: "استلم تأشيرتك",
visaStep4Desc: "احصل على تأشيرتك الرسمية المعتمدة مباشرة في بريدك الإلكتروني.",

trackEyebrow: "وصول مباشر للبوابة",
      trackHeroTitle1: "تتبع طلب",
      trackHeroTitleWord: "التأشيرة",
      trackHeroSubtitle: "أدخل رقم مرجع الطلب أدناه للحصول على تحديثات السفارة المباشرة، والتحقق من الحالة، وتقديرات المعالجة.",
      trackInputPlaceholder: "مثال: VSA-8921-2026 أو رقم الجواز",
      trackSubmitBtn: "تتبع الحالة",
      trackSearchingBtn: "جاري البحث...",
      trackBadgeEncrypted: "تشفير 256 بت",
      trackBadgeEmbassySync: "ربط مباشر مع السفارة",
      trackBadgeSupport: "دعم أولوية 24/7",

      trackRefCodeLabel: "رمز المرجع",
      trackDestinationLabel: "الوجهة",
      trackStatusPill: "قيد المعالجة في السفارة",
      trackStep1Title: "تم التقديم",
      trackStep2Title: "مراجعة المستندات",
      trackStep3Title: "مراجعة السفارة",
      trackStep3Date: "قيد الإجراء",
      trackStep4Title: "الجواز جاهز",
      trackStep4Date: "معلق",
      trackEstCompletion: "الموعد المتوقع للاكتمال:",
      trackDownloadBtn: "تحميل الإيصال",
      trackAlertDownload: "جاري تحميل الإيصال...",

      trackFaqMainTitle: "هل تحتاج إلى مساعدة في العثور على طلبك؟",
      trackFaqMainSubtitle: "الأسئلة الشائعة المتعلقة بالتتبع وأرقام المراجع",
      trackFaqQ1Title: "أين أجد رقم المرجع الخاص بي؟",
      trackFaqQ1Desc: "تم إرسال رمز التتبع الخاص بك إلى بريدك الإلكتروني المسجل وإيصال SMS مباشرة بعد إتمام عملية الدفع.",
      trackFaqQ2Title: "كم مرة يتم تحديث الحالة؟",
      trackFaqQ2Desc: "تتحدث التغييرات تلقائيًا كلما سجل فريق التحقق أو السفارة المستهدفة مرحلة جديدة.",
      trackFaqQ3Title: "هل تواجه مشكلة في البحث؟",
      trackFaqQ3Desc: "تأكد من كتابة رمز المرجع بدون مسافات إضافية، أو قم بزيارة لوحة التحكم الخاصة بك لمشاهدة الطلبات النشطة.",
      scBadge: "خبراء تأشيرة الشنغن الرائدون في عمان",
      scHeroTitle1: "حلول تأشيرة سلسة إلى",
      scHeroTitleWord: "أوروبا",
      scHeroSubtitle: "استمتع بتجربة سفر خالية من التوتر. بنقدم توجيه شامل، وحجز مواعيد مضمون، وإعداد دقيق للطلبات بنسبة قبول تتجاوز 94%.",
      scBookBtn: "احجز تقييم مجاني",
      scOurProcessBtn: "طريقة عملنا",

      // Section Titles
      scTypesEyebrow: "خيارات مخصصة",
      scTypesTitle: "اختر نوع التأشيرة",
      scMostPopular: "الأكثر طلباً",
      scApplyUnderCat: "قدّم تحت هذه الفئة",

      scDestEyebrow: "الوجهات",
      scDestTitle: "استكشف 27 دولة أوروبية",

      scStepsEyebrow: "كيف نعمل",
      scStepsTitle: "أربع خطوات للحصول على تأشيرتك",

      scDocsEyebrow: "قائمة المستندات",
      scDocsTitle: "المستندات المطلوبة",

      scFaqEyebrow: "لديك أسئلة؟",
      scFaqTitle: "الأسئلة الشائعة",

      scCtaEyebrow: "ابدأ اليوم",
      scCtaTitle: "جاهز للتخطيط لرحلتك؟",
      scCtaSubtitle: "املأ النموذج لتحديد موعد استشارة مع خبراء تأشيرة الشنغن لدينا في مسقط.",
      scCtaLocation: "مسقط، سلطنة عمان",
      scFormTitle: "طلب تقييم مجاني",
      scFormName: "الاسم الكامل",
      scFormEmail: "البريد الإلكتروني",
      scFormPhone: "رقم الهاتف / واتساب",
      scFormSelectDest: "اختر الوجهة المطلوبة",
      scFormSubmitBtn: "إرسال الطلب",

      // Types Data
      scType1Title: "سياحة / إقامة قصيرة",
      scType1Code: "تأشيرة نوع C",
      scType1Duration: "حتى 90 يوماً",
      scType1F1: "السياحة والعطلات",
      scType1F2: "زيارة الأقارب والأصدقاء",
      scType1F3: "المؤتمرات القصيرة",
      scType1F4: "الفعاليات الثقافية",

      scType2Title: "دخول متعدد",
      scType2Code: "متعددة الدخول طويلة الأمد",
      scType2Duration: "صلاحية من سنة إلى 5 سنوات",
      scType2F1: "رحلات الأعمال المتكررة",
      scType2F2: "الزوار المتكررون لمنطقة الشنغن",
      scType2F3: "وصول مرن إلى أوروبا",
      scType2F4: "استشارة أولوية",

      scType3Title: "تأشيرة ترانزيت",
      scType3Code: "تأشيرة نوع A / B",
      scType3Duration: "توقف قصير",
      scType3F1: "ترانزيت المطار",
      scType3F2: "الرحلات المتصلة en-route",
      scType3F3: "توقف قصير بالمطار",
      scType3F4: "معالجة فورية",

      // Steps Data
      scStep1Title: "حجز استشارة",
      scStep1Desc: "احجز استشارة مجانية مع خبراء الشنغن المعتمدين لتقييم ملفك واستراتيجية الوجهة.",
      scStep2Title: "تجهيز المستندات",
      scStep2Desc: "يقوم متخصصونا بتجهيز وتدقيق كل مستند مطلوب — كشف الحساب، خطة السفر، حجز الفندق، والتأمين.",
      scStep3Title: "موعد السفارة",
      scStep3Desc: "نؤمن لك موعداً في أقرب تاريخ ممكن ونجهزك بالكامل للمقابلة والبصمة.",
      scStep4Title: "صدور التأشيرة",
      scStep4Desc: "تتبع حالتك مباشرة. نتابع مع السفارة مباشرة ونبلغك فور جاهزية تأشيرتك.",

      // Documents Data
      scDoc1: "جواز سفر ساري (صلاحية 6 أشهر على الأقل)",
      scDoc2: "نموذج طلب تأشيرة شنغن مكتمل وموقع",
      scDoc3: "صورتان شخصيتان حديثتان (معيار بيومتري 35×45 مم)",
      scDoc4: "حجز طيران مؤكد وخطة سفر تفصيلية",
      scDoc5: "حجز فندقي مؤكد أو دعوة مستضيف",
      scDoc6: "تأمين سفر شنغن (تغطية 30,000€ كحد أدنى)",
      scDoc7: "كشف حساب بنكي رسمي (لآخر 3 إلى 6 أشهر)",
      scDoc8: "شهادة عدم مانع (NOC) من جهة العمل / الكفيل",
      scDoc9: "قسائم الراتب الحديثة / إثبات الدخل",
      scDoc10: "إثبات الحالة الاجتماعية (عقد زواج / سجل الأسرة)",

      // FAQ Data
      scFaqQ1: "كم تستغرق معالجة تأشيرة الشنغن من سلطنة عمان؟",
      scFaqA1: "تستغرق المعالجة عادة 15 يوماً تقويمياً من يوم موعد السفارة. في مواسم الذروة (مايو-أغسطس)، قد تستغرق من 30 إلى 45 يوماً. نوصي بشدة بالتقديم قبل 6 إلى 8 أسابيع من موعد السفر.",
      scFaqQ2: "أيي سفارة شنغن يجب أن أقدم عليها؟",
      scFaqA2: "يجب التقديم لصفارة الدولة التي تنوي قضاء أكبر عدد من الأيام فيها. إذا كانت الأيام متساوية، قدم لسفارة وجهة دخولك الأولى لمنطقة الشنغن.",
      scFaqQ3: "هل يمكنني الحصول على تأشيرة شنغن متعددة الدخول؟",
      scFaqA3: "نعم. المتقدمون بسجل سفر جيد ودعم مالي قوي وتأشيرات شنغن سابقة مؤهلون للحصول على تأشيرات متعددة الدخول من سنة إلى 5 سنوات.",
      scFaqQ4: "ما هي نسبة النجاح للمقيمين في عمان؟",
      scFaqA4: "يتمتع المقيمون في عمان بملفات مكتملة بنسبة قبول عالية جداً. وكالتنا تحافظ على نسبة قبول +94% بضمان خلو الأوراق من أي أخطاء.",

      // Country Names
      scCountryGermany: "ألمانيا",
      scCountryFrance: "فرنسا",
      scCountryItaly: "إيطاليا",
      scCountrySpain: "إسبانيا",
      scCountryNetherlands: "هولندا",
      scCountryAustria: "النمسا",
      scCountrySwitzerland: "سويسرا",
      scCountryBelgium: "بلجيكا",
      scCountryPortugal: "البرتغال",
      scCountryGreece: "اليونان",
      scCountrySweden: "السويد",
      scCountryDenmark: "الدنمارك",
      visaSupportService: "خدمة دعم التأشيرة",
      dtHeroLine1: "حجز طيران مؤكد ومتحقق منه —",
      dtHeroLine2: "جاهز لملف التأشيرة الخاص بك",
      dtHeroSub: "احصل على رمز حجز (PNR) حقيقي وصادر عن شركة الطيران كإثبات لمتابعة السفر لطلب تأشيرة الشنغن أو السفارة — يصلك عبر البريد الإلكتروني خلال 30 دقيقة، دون الحاجة لدفع سعر التذكرة الكامل.",
      reserveNow: "احجز تذكرتي المبدئية",
      trustTicketLabel: "رمز حجز (PNR) رسمي",
      trustClockLabel: "تسليم خلال 30 دقيقة",
      trustShieldLabel: "مقبول 100% لدى السفارات",
      trustGlobeLabel: "تأشيرات الشنغن والعالم",

      // ── BOOKING FORM ──
      reserveYours: "احجز حجزك",
      dtFormTitle: "طلب تذكرة طيران مبدئية",
      dtSideEyebrow: "قبل التقديم",
      dtSideTitle: "أشياء يفضل تجهيزها",
      dtSideText: "هذا يساعدنا على تسريع إصدار الحجز وتجنب عدم المطابقة مع جواز سفرك.",
      dtSidePoint1: "الاسم الكامل تماماً كما هو في جواز السفر",
      dtSidePoint2: "رقم جواز السفر والجنسية",
      dtSidePoint3: "توارخ السفر المفضلة",
      dtSidePoint4: "بريد إلكتروني صالحة لاستلام الملف PDF",

      // Form Success
      dtSuccessTitle: "تم استلام الطلب",
      dtSuccessText: "يقوم فريقنا بإعداد حجزك الآن. ستتلقى خط سير الرحلة عبر البريد الإلكتروني قريباً.",

      // Form Fields & Controls
      planOneWay: "اتجاه واحد",
      planRoundTrip: "ذهاب وإياد",
      fullNamePassport: "الاسم الكامل (وفقاً لجواز السفر)",
      passportNumber: "رقم جواز السفر",
      nationality: "الجنسية",
      nationalityPlaceholder: "مثال: عماني",
      numberOfTravelers: "عدد المسافرين",
      departureCity: "مدينة المغادرة",
      departureCityPlaceholder: "مثال: مسقط (MCT)",
      destinationCity: "مدينة الوصول",
      destinationCityPlaceholder: "مثال: باريس (CDG)",
      departureDate: "تاريخ المغادرة",
      returnDate: "تاريخ العودة",
      email: "البريد الإلكتروني",
      whatsappPhone: "واتساب / الهاتف",
      additionalNotes: "ملاحظات إضافية (اختياري)",
      notesPlaceholder: "اسم السفارة، تاريخ الموعد، أو أي طلب خاص",
      submitRequest: "إرسال الطلب",

      // ── WHATSAPP STRIP ──
      dtWaTitle: "تحتاجها خلال ساعة؟",
      dtWaText: "تواصل معنا عبر الواتساب للحصول على حجز عاجل في نفس اليوم.",
      chatOnWhatsapp: "المحادثة عبر الواتساب",

  "visaApplicationDesc": "قدم على تأشيرتك بسهولة",
  "trackApplicationDesc": "تحقق من حالتك في الوقت الفعلي",
  "schengenVisa": "تأشيرة شنغن",
  "schengenVisaDesc": "المتطلبات والإرشادات",
  "dummyTicketDesc": "مسار الرحلة للتأشيرة",
  "travelInsurance": "التأمين السفر",
  "travelInsuranceDesc": "تغطية عالمية",

  "otherCountries": "دول أخرى",
  "oman": "عمان",
  "visaForOman": "تأشيرة إلكترونية",
  "uae": "الإمارات",
  "visaForUae": "دبي والإمارات",
  "saudiArabia": "المملكة العربية السعودية",
  "visaForKsa": "العمرة والسياحة",
  "bahrain": "البحرين",
  "visaForBahrain": "معالجة سريعة",
  "kuwait": "الكويت",
  "visaForKuwait": "معالجة رسمية",
  "qatar": "قطر",
  "visaForQatar": "هيا وسياحية",
  "thailand": "تايلاند",
  "visaForThailand": "بوابة استوائية",
  "india": "الهند",
  "visaForIndia": "خدمات التأشيرة الإلكترونية",
  "armenia": "أرمينيا",
  "visaForArmenia": "دخول سريع",
  "usa": "الولايات المتحدة",
  "visaForUsa": "دعم تأشيرة B1/B2",
  "canada": "كندا",
  "visaForCanada": "إرشاد تأشيرة الزوار",
  "hot": "ساخن",
  "myBookings": "حجوزاتي",
  "signOut": "تسجيل الخروج",
  "footerBrandTitle": "الجرز الفضي للسفر",
  "footerBrandDesc": "شريك السفر الموثوق به للحصول على التأشيرات في جميع أنحاء العالم، والرحلات السياحية المخصصة، وتأجير السيارات الفاخرة.",
  
  "footerServicesTitle": "خدماتنا",
  "footerVisaServices": "خدمات التأشيرات",
  "footerTourPackages": "الباقات السياحية",
  "footerCarRentals": "تأجير السيارات",
  "footerFlightBooking": "حجز الرحلات الجوية",

  "footerCompanyTitle": "الشركة",
  "footerAboutUs": "من نحن",
  "footerBlog": "المدونة",
  "footerFaq": "الأسئلة الشائعة",

  "footerSupportTitle": "الدعم والشؤون القانونية",
  "footerContactUs": "اتصل بنا",
  "footerPrivacyPolicy": "سياسة الخصوصية",
  "footerTerms": "الشروط والأحكام",
  "footerPaymentInfo": "معلومات الدفع",
  "footerLegalDisclaimer": "إخلاء المسؤولية القانونية",
  // Why Choose Us - BlockGuide
bestPriceGuarantee: "ضمان أفضل سعر",
bestPriceGuaranteeText: "أسعار شفافة على كل تأشيرة ورحلة وتأجير — بدون رسوم خفية، أبداً.",
easyQuickBooking: "حجز سهل وسريع",
easyQuickBookingText: "احجز التأشيرات والرحلات والجولات في دقائق، من أي جهاز، مع تأكيد فوري.",
customerCare247: "خدمة العملاء 24/7",
customerCare247Text: "أشخاص حقيقيون، ليلاً ونهاراً — فريقنا في مسقط دائماً على بعد مكالمة واحدة.",
handpickedDestinations: "وجهات مختارة بعناية",
handpickedDestinationsText: "فنادق وسائقون وتجارب منسقة في أشهر مواقع عمان.",
// FAQ Page
faqEyebrow: "مركز الدعم",
faqSubtitle: "إجابات مباشرة حول التأشيرات والجولات وتأجير السيارات في عمان — من مستندات الطلب إلى ما يحدث في حالة حدوث خطأ. لا تجدها هنا؟ فريقنا على بعد رسالة.",
faqAllQuestions: "جميع الأسئلة",
faqCategoryVisa: "خدمات التأشيرات",
faqCategoryTravel: "الجولات والسفر",
faqCategoryCar: "تأجير السيارات",
faqCategoryGeneral: "المدفوعات والدعم",

// FAQ Visa Questions
faqVisaQ1: "ما هي التأشيرات التي يمكنني التقدم لها من خلال سيلفر جارز؟",
faqVisaA1: "نحن نتعامل مع تأشيرات السياحة والزيارة لمنطقة شنغن، عمان، المملكة العربية السعودية، قطر، البحرين، الكويت، المملكة المتحدة، الولايات المتحدة، كندا، الهند، تايلاند وأرمينيا، من بين دول أخرى. إذا لم تكن وجهتك مدرجة، اسألنا مباشرة — نحن نضيف بانتظام وجهات جديدة بناءً على الطلب.",
faqVisaQ2: "كم تستغرق معالجة التأشيرة؟",
faqVisaA2: "تتم معالجة معظم تأشيرات الدخول الفردي في غضون 3-5 أيام عمل بمجرد اكتمال ملفك. قد تستغرق تأشيرات الدخول المتعدد وبعض التأشيرات المعتمدة على السفارة ما يصل إلى 7 أيام. سنقدم لك تقديراً محدداً لوجهتك وجواز سفرك قبل أن تدفع أي شيء.",
faqVisaQ3: "ما هي المستندات التي أحتاجها للتقديم؟",
faqVisaA3: "كحد أدنى: جواز سفر صالح لمدة 6 أشهر على الأقل بعد تاريخ سفرك، صور بحجم جواز السفر، إثبات العمل أو الدخل، وحسب الوجهة — حجز فندق، حجز طيران وتأمين سفر. يقوم فريقنا بمراجعة ملفك قبل التقديم ويخبرك بالضبط ما هو ناقص، حتى لا تتعرض للرفض بسبب نقص في الأوراق.",

faqVisaQ4: "ماذا يحدث إذا تم رفض تأشيرتي؟",
faqVisaA4: "الأمر نادر — نسبة الموافقة لدينا تبلغ حوالي 98% لأننا نفحص الطلبات قبل وصولها إلى السفارة — ولكن إذا حدث رفض، فإننا نراجع السبب معك، ونصحح الملف، ونعيد التقديم دون رسوم خدمة إضافية حيث كان الرفض مرتبطاً بمشكلة وثائق قابلة للحل. رسوم السفارة نفسها غير قابلة للاسترداد، كما هو الحال مع أي طلب تأشيرة في جميع أنحاء العالم.",
faqVisaQ5: "هل تقدمون تذاكر مؤقتة وتأمين سفر لملف التأشيرة؟",
faqVisaA5: "نعم. تطلب العديد من السفارات حجز طيران وشهادة تأمين كجزء من الطلب، حتى قبل حجز الرحلات الفعلية. نحن نوفر كليهما كإضافات حتى يكون ملف التأشيرة مكتملاً في التقديم الأول.",

// FAQ Travel Questions
faqTravelQ1: "هل تقدمون باقات ثابتة، أم يمكنكم بناء رحلة مخصصة؟",
faqTravelA1: "كلاهما. باقاتنا المنشورة (مثل رحلات خليج مسندم أو رحلات التراث في مسقط) جاهزة للحجز كما هي، ولكن معظم العملاء يطلبون منا تعديل المدة أو فئة الفندق أو إضافة محطات — أخبرنا بتواريخك وميزانيتك وسنقوم بإعداد مسار مخصص.",
faqTravelQ2: "ما الذي يتضمنه عادة سعر باقة الجولة؟",
faqTravelA2: "الإقامة، النقل الخاص أو المشترك، الجولات المدرجة ومرشد محلي حيثما ينطبق ذلك. الرحلات الجوية، الوجبات خارج المسار، والنفقات الشخصية عادة ما تكون منفصلة ما لم تذكر الباقة صراحة 'شامل كل شيء'. نحن ندرج التضمينات الدقيقة في كل صفحة باقة قبل أن تحجز.",
faqTravelQ3: "هل يمكنكم التعامل مع التأشيرة والرحلة معاً؟",
faqTravelA3: "نعم — هذا هو الطلب الأكثر شيوعاً الذي نتلقاه. أخبرنا بوجهتك وتواريخ سفرك، وسنقوم بتنسيق الجدول الزمني للتأشيرة مع حجوزات الطيران والفندق بحيث لا يتبقى شيء في اللحظة الأخيرة.",

// FAQ Car Questions
faqCarQ1: "ما الذي أحتاجه لاستئجار سيارة في عمان؟",
faqCarA1: "رخصة قيادة سارية (تصريح قيادة دولي إلى جانب رخصتك المحلية إذا لم تكن باللغتين الإنجليزية أو العربية)، جواز سفر أو بطاقة هوية عمانية، ووديعة تأمين قابلة للاسترداد محفوظة على بطاقة. الحد الأدنى لعمر المستأجر هو 21 عاماً، ويرتفع إلى 25 عاماً لسيارات الدفع الرباعي الكبيرة والطرازات الفاخرة.",
faqCarQ2: "هل يمكنني أخذ سيارة مستأجرة عبر الحدود إلى عمان؟",
faqCarA2: "الرحلات عبر الحدود ممكنة ولكن يجب ترتيبها مسبقاً — نصدر تصريح عبور الحدود ونؤكد أن تأمينك يغطي طرق الإمارات قبل المغادرة. القيادة إلى دولة مجاورة دون هذه الأوراق ستبطل تأمينك، لذا أشر إلى ذلك دائماً عند الحجز.",
faqCarQ3: "هل التأمين مشمول في سعر الإيجار؟",
faqCarA3: "يشمل كل إيجار تأمين طرف ثالث أساسي بشكل افتراضي. نقدم أيضاً خيارات إضافية مثل التنازل عن أضرار التصادم والحماية من السرقة التي تقلل مسؤوليتك إلى الصفر في حالة وقوع حادث — نوصي بها لأي شخص غير معتاد على القيادة في عمان.",

// FAQ General Questions
faqGeneralQ1: "ما هي طرق الدفع التي تقبلونها؟",
faqGeneralA1: "النقد، بطاقات الخصم/الائتمان الرئيسية، والتحويل البنكي. تتطلب حجوزات التأشيرة والجولات عادة دفعة مقدمة لتأكيد تواريخك، مع استحقاق الرصيد المتبقي قبل أو عند الوصول — سنؤكد التقسيم الدقيق لحجزك مسبقاً.",
faqGeneralQ2: "هل يمكنني التواصل مع الدعم أثناء سفري؟",
faqGeneralA2: "نعم — خط الدعم لدينا يعمل 24/7 عبر الهاتف والواتساب لهذا السبب تحديداً. إذا تغيرت رحلة طيران، أو ظهرت مشكلة في الفندق، أو احتجت للتحقق من حالة التأشيرة أثناء الرحلة، لن تنتظر حتى يفتح مكتب مسقط.",

// FAQ Beyond Section
faqBeyondEyebrow: "ما بعد الأسئلة الشائعة",
faqBeyondTitle: "كيف نساعد فعلياً",
faqBeyondSub: "الأجزاء من العملية التي لا تتناسب مع إجابة من سطر واحد.",

// FAQ Support Cards
faqSupport1Title: "مراجعة مجانية للمستندات",
faqSupport1Text: "أرسل مستنداتك قبل أن تلتزم بأي شيء — سنخبرك بصدق إذا كان ملفك قوياً بما فيه الكفاية، وما الذي يجب إصلاحه إذا لم يكن كذلك.",
faqSupport2Title: "تحديثات الحالة في الوقت الفعلي",
faqSupport2Text: "لا حاجة للتخمين حول مكان طلبك — تحصل على تحديث الحالة أثناء تحرك تأشيرتك عبر كل مرحلة، وليس فقط عند التقديم والموافقة.",
faqSupport3Title: "نقطة اتصال واحدة",
faqSupport3Text: "سواء كانت تأشيرة، أو جولة، أو سيارة مستأجرة، تتعامل مع نفس الفريق — لا حاجة للتنقل بين الأقسام لتنظيم رحلة واحدة.",
faqSupport4Title: "14+ سنة في عمان",
faqSupport4Text: "نحن نرتب التأشيرات والرحلات من عمان منذ عام 2010 — ما يكفي لمعرفة أي السفارات صارمة بشأن ماذا، والتخطيط وفقاً لذلك.",
faqSupport5Title: "دعم باللغتين العربية والإنجليزية",
faqSupport5Text: "يعمل فريقنا معك باللغة التي تشعر براحة أكبر فيها، حتى لا يضيع أي شيء بين ما تحتاجه وما يتم تقديمه.",
faqSupport6Title: "تم خدمة 26,000+ مسافر",
faqSupport6Text: "من المتقدمين الأوائل لتأشيرة شنغن إلى المسافرين الدائمين — الأسئلة أعلاه تأتي من حالات تعاملنا معها فعلياً، وليس من قالب عام.",

// FAQ CTA Section
faqCtaEyebrow: "لا تزال عالقاً؟",
faqCtaTitle: "اسألنا مباشرة — بدون قائمة انتظار",
faqCtaSub: "راسل فريقنا على واتساب أو اتصل بالمكتب. معظم الأسئلة تحصل على إجابة حقيقية خلال ساعة خلال ساعات العمل، وليس رداً آلياً.",
faqContactBtn: "اتصل بنا",
faqWhatsappBtn: "راسلنا على واتساب",

// Ticket Page - Request a Flight Ticket
ticketPageTitle: "طلب تذكرة الطيران الخاصة بك",
ticketPageSubtitle: "املأ تفاصيل سفرك أدناه وسيؤكد فريقنا حجزك خلال 24 ساعة.",
ticketBreadcrumbHome: "الرئيسية",
ticketBreadcrumbTravel: "السفر",
ticketBreadcrumbCurrent: "طلب تذكرة",
ticketCardTitle: "طلب تذكرة طيران",
ticketCardSubtitle: "أكمل جميع الأقسام · سنتصل بك للتأكيد",

// Steps
ticketStep1: "تفاصيل الرحلة",
ticketStep2: "المسافرون",
ticketStep3: "معلومات الاتصال",

// Trip Configuration
tripConfigTitle: "تكوين الرحلة",
tripTypeLabel: "نوع الرحلة",
tripTypeRoundtrip: "ذهاب وإياب",
tripTypeOneway: "ذهاب فقط",
tripTypeMulticity: "متعدد المدن",
routeTitle: "المسار",
flyingFrom: "المغادرة من",
flyingFromPlaceholder: "مدينة أو مطار (مثال: مدريد MAD)",
flyingTo: "الوصول إلى",
flyingToPlaceholder: "مدينة أو مطار (مثال: باريس CDG)",
viaStopover: "عبر (توقف)",
viaPlaceholder: "مدينة أو مطار توقف اختياري",
dateFlexibility: "مرونة المواعيد",
dateFlexibilityExact: "تواريخ محددة فقط",
dateFlexibility1Day: "± يوم واحد",
dateFlexibility3Days: "± 3 أيام",
dateFlexibility1Week: "± أسبوع واحد",
dateFlexibilityFlexible: "مرن بالكامل",
baggagePreference: "تفضيل الأمتعة",
baggage1Bag: "حقيبة واحدة (حتى 23 كجم)",
baggage2Bags: "حقيبتان (حتى 23 كجم لكل منهما)",
baggagePremium: "أمتعة مميزة (32 كجم لكل منهما)",
baggageCabinOnly: "أمتعة يدوية فقط",
preferredAirline: "شركة الطيران المفضلة",
preferredAirlinePlaceholder: "اختياري (مثال: الخطوط الجوية الفرنسية)",
continueToPassengers: "متابعة إلى المسافرين ←",

// Passengers
passengersTitle: "عدد المسافرين",
adults: "بالغين",
adultsSub: "18 سنة فأكثر",
children: "أطفال",
childrenSub: "من 2 إلى 17 سنة",
infants: "رضع",
infantsSub: "أقل من سنتين (في الحضن)",
leadPassengerTitle: "تفاصيل المسافر الرئيسي",
firstName: "الاسم الأول",
firstNamePlaceholder: "كما في جواز السفر",
lastName: "اسم العائلة",
lastNamePlaceholder: "كما في جواز السفر",
passportNumberPlaceholder: "مثال: AB1234567",
passportExpiry: "انتهاء صلاحية جواز السفر",
passportExpiryMonth: "الشهر",
passportExpiryYear: "السنة",
specialRequests: "طلبات خاصة",
specialRequestsPlaceholder: "مثال: مساعدة كرسي متحرك، تفضيل الوجبات، تفضيل المقعد (نافذة/ممر)…",
back: "رجوع",

// Contact

emailPlaceholder: "your@email.com",
requestSummary: "ملخص الطلب",
route: "المسار",

departure: "المغادرة",
return: "العودة",
passengers: "المسافرون",
cabin: "درجة السفر",
baggage: "الأمتعة",
leadPassenger: "المسافر الرئيسي",
termsConfirm: "أؤكد أن جميع المعلومات المقدمة دقيقة وأوافق على",
termsConditions: "الشروط والأحكام",
and: "و",
submitting: "جاري إرسال طلبك…",

// Success
requestSubmitted: "تم إرسال الطلب!",
requestSubmittedText: "شكراً لك. تم استلام طلب تذكرة السفر الخاص بك. سيقوم فريقنا بمراجعة تفاصيلك والتواصل معك خلال",
toConfirm: "لتأكيد حجزك.",
reference: "المرجع",
submitAnother: "تقديم طلب آخر",

// Side Panel
step1TitleFlight: "قدم طلبك",
step1TextFlight: "املأ تفاصيل سفرك ومعلومات المسافرين.",
step2TitleFlight: "نبحث لك",
step2TextFlight: "فريقنا يبحث عن أفضل الأسعار المتاحة عبر جميع شركات الطيران.",
step3TitleFlight: "التأكيد خلال 24 ساعة",
step3TextFlight: "نتواصل معك مع الخيارات ونؤكد حجزك.",
step4TitleFlight: "استلم تذكرتك",
step4TextFlight: "يتم إرسال تذكرتك الإلكترونية مباشرة إلى بريدك الإلكتروني.",
ourGuarantees: "ضماناتنا",
guaranteeBestPrice: "أفضل سعر",
guaranteeFreeCancellation: "إلغاء مجاني",
guaranteeSecurePayment: "دفع آمن",
guaranteeSupport: "دعم 24/7",
guaranteeAirlines: "500+ شركة طيران",
guaranteeETicket: "تذكرة إلكترونية",
needAssistance: "بحاجة إلى مساعدة؟",
phone: "الهاتف",
hoursLabel: "ساعات العمل",
hoursValue: "الإثنين–الأحد 8:00 – 20:00",

// Auth Modal
authRequired: "مطلوب تسجيل الدخول",
authRequiredText: "لتقديم طلب تذكرة طيران والوصول إلى عروض سفر مخصصة، يرجى تسجيل الدخول إلى حسابك.",
signInToContinue: "سجل الدخول للمتابعة",
continueBrowsing: "مواصلة التصفح",

// Validation Errors
errorRequired: "هذا الحقل مطلوب.",
errorSelectFrom: "يرجى اختيار مدينة أو مطار المغادرة.",
errorSelectTo: "يرجى اختيار مدينة أو مطار الوصول.",
errorNameLetters: "استخدم الحروف فقط، 2-50 حرفاً.",
errorSelectNationality: "يرجى اختيار جنسيتك.",
errorPassportInvalid: "أدخل رقم جواز سفر صحيح (5-15 حرفاً أو رقماً).",
errorSelectMonth: "اختر الشهر.",
errorSelectYear: "اختر السنة.",
errorEmailInvalid: "أدخل عنوان بريد إلكتروني صحيح.",
errorPhoneInvalid: "أدخل رقم هاتف صحيح (7-16 رقماً، قد يبدأ بـ +).",
errorPassportExpired: "يبدو أن جواز السفر منتهي الصلاحية.",
errorAcceptTerms: "يرجى قبول الشروط والأحكام للمتابعة.",
errorCompleteFields: "أكمل جميع الحقول المطلوبة قبل المتابعة.",
errorDepartureDate: "يرجى اختيار تاريخ المغادرة.",
errorReturnDate: "يرجى اختيار تاريخ العودة.",

// Car Rental Page
carRentalSeoTitle: "تأجير السيارات — قريباً | سيلفر جارز",
carRentalSeoDescription: "سيلفر جارز تستعد لتقديم خيارات مرنة وفاخرة لتأجير السيارات في عمان. اترك بريدك الإلكتروني ليتم إعلامك عند فتح الحجوزات.",
carRentalEyebrow: "يومي · أسبوعي · شهري",
carRentalTitle: "أسطول",
carRentalTitleEm: "التأجير",
carRentalSubtitle: "سيارات مرنة ومجهزة بشكل جيد لكل رحلة — احجز عبر الإنترنت وقُد بثقة.",
carFilterAll: "جميع السيارات",
carFilterAutomatic: "أوتوماتيك",
carFilterManual: "يدوي",
daily: "يومي",
monthly: "شهري",
yearly: "سنوي",
rate: "السعر",
seats: "مقاعد",
viewAndBook: "عرض وحجز",
carError: "تعذر تحميل الأسطول حالياً. يرجى المحاولة مرة أخرى قريباً.",
carEmpty: "لا توجد سيارات تطابق هذا الفلتر حالياً.",
promoModalTag: "عرض لفترة محدودة",
promoModalTitle: "وفّر في",
promoModalTitleEm: "تأجيرك القادم",
promoModalText: "احجز مباشرة من خلال أسطولنا اليوم واستمتع بأسعار يومية وشهرية وسنوية مرنة — بدون رسوم خفية وإلغاء مجاني حتى 24 ساعة قبل الاستلام.",
promoPerk1: "سيارات مجهزة بشكل جيد ومؤمنة بالكامل",
promoPerk2: "أسعار مرنة يومية وشهرية وسنوية",
promoPerk3: "حجز فوري عبر الإنترنت، بدون أوراق",
promoBrowseBtn: "تصفح الأسطول",
promoLaterBtn: "ربما لاحقاً",
  
    },

  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;